import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "../components/TranslationText";
import "react-image-gallery/styles/css/image-gallery.css";
import Popup from "reactjs-popup";
import {
  FetchChampionshipResultthunk,
  FetchLastShowsthunk,
  FetchShowChampionshipCardsthunk,
  FetchShowClassHorseSoringDetailsthunk,
  FetchShowClassRankListthunk,
  FetchShowClassesthunk,
  FetchShowGallerythunk,
  FetchShowJudgesthunk,
  FetchShowbyIdthunk,
  FetchShowsGallery,
  FetchShowsNews,
  FetchShowsthunk,
} from "../Redux/Shows/ShowsAction";
import NetaqInput from "../components/NetaqInput";
import ImageGallery from "react-image-gallery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import OwlCarousel from "react-owl-carousel";
import Loader from "../components/Loader";
import Lightbox from "react-18-image-lightbox";
import { convertToCamelCase } from "../helper/convertToCamelCase";
import "react-18-image-lightbox/style.css";
import { truncateString } from "../helper/truncateString";
import {
  translateDayToArabic,
  translateMonthToArabic,
} from "../helper/translateDayToArabic";
import FilterButton from "../components/FilterButton";
import Album from "../components/Album";
import ImagesSlider from "../components/ImagesSlider";
import { formatDate } from "../helper/formatDate";
import { showFirstFourWords, showFirstSixWords } from "../helper/showFirstSixWords";
import axiosInstance from "../axios/axios";
import ActionButton from "../components/ActionButton";
import JudgeList from "../components/JudgeList";
import EahsForm from "../components/EahsForm";
import PillBtn from "../components/PillBtn";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import SectionTitle from "../components/SectionTitle";
import { btnContainerShow, pageTitleShow } from "../common/cssclasses";
import CustomPopUp from "../components/CustomPopUp";
import NewsItemHome from "../components/NewsItemHome";
import HorseResultsTable from "../components/HorseResultsTable";
import { formatLongDate } from "../helper/formatLongDate";
import InAreanHorse from "../components/TempRanking";
import OnAirHorse from "../components/OnAirHorse";
import { getOrdinal } from "../helper/getOrdinal";
import TempRanking from "../components/TempRanking";
import SpecialPrizesSection from "../components/SpecialPrizesSection";
import { getChampionResultById } from "./sharedAPI/lookUpApis";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function ShowDetails() {
  const dispatch = useDispatch();
  const [firestoreDataJdges, setFireStoreDataJugdes] = useState([]);
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const [championHorseTableData, setChampionHorseTableData] = useState([])
  const [championHorseTableHeader, setChampionHorseTableHeader] = useState([])
  const [championHorseTableDataLive, setChampionHorseTableDataLive] = useState([])
  const [championHorseTableHeaderLive, setChampionHorseTableHeaderLive] = useState([])

  function openChamp(championId, horseId, isLive = false) {
    getChampionResultById(championId, horseId).then(res => {
      if (isLive) {
        debugger;
        setChampionHorseTableDataLive(res?.results)
        setChampionHorseTableHeaderLive(res?.headers)
      } else {
        setChampionHorseTableHeader(res?.headers)
        setChampionHorseTableData(res?.results)
      }
    })
  }

  const [championshipName, setChampionshipName] = useState("");

  const [openPopup, setOpenPopup] = useState(false);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [scoringId, setScoringId] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(-1);
  const [isOpen, setIsOpen] = useState(false);
  const [showLastFilter, setShowLastFilter] = useState(false);
  const [images, setimages] = useState([]);

  const closeModal = () => setOpenPopup(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentId = searchParams.has("id") ? searchParams.get("id") : null;

  const { translate } = useTranslate();


  const {
    showbyIdData,
    showChampionshipCardsData,
    championshipResultData,
    lastShowsData,
    showNewsData,
    showMediaData,
    showClassesData,
    showClassHorseSoringDetailsData,
    showsLoading,
  } = useSelector((state) => state.showsSlice);


  const [isFiltering, setisFiltering] = useState(false);

  const BaseURL = process.env.REACT_APP_BASE_URL;



  useEffect(() => {
    async function getShowbyId() {
      let paramsShowbyId = {
        id: currentId,
        langauge: currentLanguage,
      };
      dispatch(FetchShowbyIdthunk(paramsShowbyId));
      dispatch(FetchShowJudgesthunk(paramsShowbyId));
      dispatch(FetchShowClassRankListthunk(paramsShowbyId));
      dispatch(FetchShowChampionshipCardsthunk(paramsShowbyId));
      dispatch(FetchShowGallerythunk(paramsShowbyId));
      dispatch(FetchShowsGallery(paramsShowbyId));
      dispatch(FetchShowsNews(paramsShowbyId));
      dispatch(FetchShowClassesthunk(paramsShowbyId));

      let paramsShows = {
        skip: 0,
        take: 100,
        langauge: currentLanguage,
        showName: null,
        year: null,
        month: 0,
        emirateId: null,
        showStatus: [],
      };
      dispatch(FetchLastShowsthunk(paramsShows));
    }

    getShowbyId();
  }, [dispatch, currentId, currentLanguage]);

  useEffect(() => {
    let paramsShowbyId = {
      id: currentId,
      langauge: currentLanguage,
    };
    dispatch(FetchShowClassesthunk(paramsShowbyId));
  }, [firestoreDataJdges, dispatch, currentLanguage])



  const handleChampionshipResult = (id) => {
    let paramsShowbyId = {
      id,
      langauge: currentLanguage,
    };
    dispatch(FetchChampionshipResultthunk(paramsShowbyId));
  };

  const handleShowsFilter = () => {
    setisFiltering(true);
    let paramsShows = {
      skip: 0,
      take: 100,
      langauge: currentLanguage,
      showName: null,
      year: year === "" ? null : year,
      month: month === "" ? 0 : Number(month),
      emirateId: null,
      showStatus: ["All"],
    };
    dispatch(FetchLastShowsthunk(paramsShows));
    setTimeout(function () {
      setisFiltering(false);
    }, 1500);
  };


  useEffect(() => {
    if (scoringId != null) {
      let params = {
        id: scoringId,
        langauge: currentLanguage,
      };
      dispatch(FetchShowClassHorseSoringDetailsthunk(params));
    }
  }, [scoringId, currentLanguage, firestoreDataJdges]);



  const handleHorseMedia = (index, albumMedia) => {
    setIsOpen(true);
    setPhotoIndex(index);
    setimages(albumMedia.map((media) => MediaBaseURL + media.url));
  };
  const handleHorseMediaClass = (albumMedia) => {
    const items = albumMedia?.filter(x => !x?.imageUrl?.includes('youtube'))
    setIsOpen(true);
    setPhotoIndex(0);
    setimages(items.map((media) => media.imageUrl));
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  function getCurrentLanguageUmbraco() {
    // Replace this with your logic to retrieve the current language
    // For example, you can retrieve it from localStorage or from a state variable
    const lang = localStorage.getItem("eahsLang") ?? "en";
    if (lang == "en") return "en-US";
    else return "ar-AE"; // Defaulting to English for demonstration
  }

  function getVideoFrame(index) {

    return (<iframe width="90%" height="90%" style={{ zIndex: 5000 }} src={images[index]} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;allowfullscreen;" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen="true"></iframe>);
  }


  const showChampionVideo = (championVideos) => {
    setimages(championVideos);
    setPhotoIndex(0);
    setIsOpen(true);
  };

  const { data, } = useSelector(state => state.showTemporaryRank);
  const enabledHorse = { color: 'var(--red) !important', textDecoration: 'underline !important' };
  const horsesRef = useRef({}); // object of refs
  const collapseRef = useRef({}); // object of refs

  const expandHorse = (id) => {
    const scrollToId = id?.toLowerCase();
    const element = collapseRef.current[scrollToId];
    if (!element) return;
    element.classList.add("show");
  }

  const scrollToTable = (id) => {
    const scrollToId = id?.toLowerCase();
    const element = horsesRef.current[scrollToId];

    if (!element) return;

    const y =
      element.getBoundingClientRect().top +
      window.pageYOffset -
      150; // ✅ offset

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
    setScoringId(scrollToId);
    expandHorse(scrollToId);
  };


  return (
    <>
      {
        // horse images swap
      }
      {isOpen && images.length > 0 && photoIndex > -1 && (
        <div>
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => { setIsOpen(false); setimages([]); setPhotoIndex(-1) }}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % images.length)
            }
            imageLoadErrorMessage={getVideoFrame(photoIndex)}
            wrapperClassName='ltr'
          />
        </div>
      )}

      <div
        className={`page-overlay text-center ${showsLoading && !isFiltering ? "classdisplay" : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      <div className="row  rtl ">
        {
          //show name
        }
        <h2 className={pageTitleShow}>
          {showbyIdData?.showName}
        </h2>
        {!!showbyIdData?.eventId &&
          <h2 className={btnContainerShow}>
            <ActionButton
              type={"internalLink"}
              to={`/book-table?eventid=${showbyIdData?.eventId}`}
              width={"100%"}
              margin={10}
              text={translate('web.bookTable', 'Book Table')}
            />
          </h2>
        }
        {
          //show details
        }
        <div className="col-md-12 col-sm-12 row mb-main  rtl ">
          {/* <div className="row"> */}
          {!!showbyIdData?.startDateObject && (
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1   ">
              <i
                className="fa fa-calendar C89C66"
              ></i>
              <span>{formatDateTimeToString(showbyIdData?.startDateObject)}  </span>
            </div>
          )}
          {!!showbyIdData?.endDateObject && (
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1   ">
              <i
                className="fa fa-calendar C89C66"
              ></i>
              <span>{formatDateTimeToString(showbyIdData?.endDateObject)}</span>
            </div>
          )}
          {!!showbyIdData?.cityName && (
            !!showbyIdData?.mapLocationSharedUrl ?
              <Link to={showbyIdData?.mapLocationSharedUrl} target="_blank" className=" col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1 ">
                <i
                  className="fa-solid fa-location-dot C89C66"
                ></i>
                <span className="C89C66">
                  {showbyIdData?.cityName}
                </span>
              </Link> :
              <div className=" col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1  ">
                <i
                  className="fa-solid fa-location-dot C89C66"
                ></i>
                <span >
                  {showbyIdData?.cityName}
                </span>
              </div>
          )}
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1  ">
            <i className="fa fa-trophy C89C66 " ></i>
            <span>{showbyIdData?.showRank}</span>
          </div>

          {!!showbyIdData?.showCatalogUrl && (
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1  ">
              <Link
                to={`/ShowCatalog?id=${currentId}`}
                className="C89C66"

              >
                <i className="fa fa-file-pdf" ></i>
                <span>
                  {translate(`web.showCatalog`, "Show Catalog")}
                </span>
              </Link>
            </div>
          )}
          {!!showbyIdData?.isMediaRequestsEnabled && (
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1  w-unset ">
              <Link
                to={`/pressCoverageRequest?showId=${currentId}`}
                className="C89C66"
              >
                <i className="fa-solid fa-clipboard" ></i>
                <span>
                  {translate(`web.pressRequest`, "Press Request")}
                </span>
              </Link>
            </div>
          )}
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-md-12 mb-main ">
              <div className="bg-white  p-main border-15 p-3 h-100">
                <ImagesSlider
                  sliderName={"bidding"}
                  data={[showbyIdData?.coverImage,showbyIdData?.promoImage].filter(Boolean)}
                  type={"show"}
                  horseName={"myname"}
                  VideoURL={[
                    showbyIdData?.liveLink,
                    showbyIdData?.promoVideoLink,
                  ].filter(Boolean)}
                />

                <OnAirHorse scrollToTable={scrollToTable} />
              </div>

            </div>
            <TempRanking showId={currentId} />
            {!!data && data.length > 0 && (
              <div className="col-xl-8 col-lg-8 col-md-12 mb-main">
                <EahsForm key={'classes'} className='mb-main' isSectionTitle={true} isNoMargin   >
                  <div className="col-md-12  responsiveRTLWidth100 text-center-rtl">
                    {!!data && data.length > 0 ? (
                      //accordionFirst
                      <div
                        className=" accordionShowDetails rtl"
                        id="accordionFirst"
                      >

                        <>
                          <div className=" panel-default rounded" key={'i2'}>
                            <div className="panel-heading accordionSecondShowDetails rounded">
                              <h4
                                className="panel-title showTableTabHeader rounded"
                                style={{
                                  backgroundColor: "var(--mainGold)",
                                }}
                              >
                                <a
                                  className={`collapsed border bg-gray`}
                                  data-bs-toggle="collapse"
                                  href={`#collapseSecondii`}
                                  aria-expanded="true"
                                  aria-controls={`collapseSecondii`}
                                  style={{ overflowX: 'hidden' }}
                                >
                                  <span className={`w-75 text-start d-inline-block text-dark`}>
                                    {currentLanguage == 'en' ? data?.at(-1)?.ClassName : data?.at(-1)?.ClassNameAr}
                                  </span>
                                  <span className={`w-25 text-end d-inline-block text-dark`}>
                                    {data?.at(-1)?.RankScoringList?.length}
                                    <i className="fa-solid fa-chess-knight ms-2"></i>
                                  </span>
                                </a>
                              </h4>
                            </div>
                            <div
                              id={`collapseSecondii`}
                              className="panel-collapse collapse show"
                              data-bs-parent={`#accordionSecondii`}
                              style={{ overflowX: 'hidden' }}
                            >
                              <div className="panel-body panelBodyResponsive">
                                {
                                  //accordionThird
                                }

                                <div
                                  className="panel-group"
                                  id={`accordionThirdii`}
                                >
                                  {data?.at(-1)?.RankScoringList?.map(
                                    (item3, i3) => (
                                      <div
                                        className=" panel-default"
                                        key={i3}
                                      >
                                        <div
                                          className={`panel-headin row   accordionThirdShowDetails border  ${i3 % 2 == 0 ? 'bg-gray' : 'bg-white'}`}
                                          key={item3?.HorseId}
                                          ref={(el) => (horsesRef.current[item3?.HorseId?.toLowerCase()] = el)}
                                          onClick={() => {
                                            if (data?.at(-1)?.Stage?.toLowerCase() == 'Championship'.toLowerCase()) {
                                              openChamp(data?.at(-1)?.Id, item3?.HorseId, true);
                                            } else {
                                              setScoringId(item3?.HorseId);
                                            }
                                          }}
                                        >
                                          <div className="panel-title showTableTabHeader  t-center-responsive floatLeftinArabic col-md-2 col-sm-6">
                                            <a
                                              className={`collapsed`}
                                              data-bs-toggle="collapse"
                                              href={`#collapseThirdii${i3}`}
                                              aria-expanded="true"
                                              aria-controls={`collapseThirdii${i3}`}
                                              dangerouslySetInnerHTML={{ __html: getOrdinal(item3?.HorseRank) }}
                                            />

                                          </div>
                                          <div className="panel-title showTableTabHeader d-flex  t-center-responsive floatLeftinArabic col-md-5 col-sm-6">

                                            {!!item3?.OriginalHorseId ?
                                              <div className="my-auto" >
                                                <span  >
                                                  <Link
                                                    target="_blank"
                                                    to={!!item3?.OriginalHorseId ? `/horseDetails?horseId=${item3?.OriginalHorseId}` : ''}
                                                  >
                                                    <span className="text-decoration-underline" style={!!item3?.OriginalHorseId ? enabledHorse : {}}>
                                                      {item3.HorseNumber} {" - "}{" "}
                                                      {currentLanguage == 'en' ? item3.HorseName : item3.HorseNameAr}
                                                    </span>
                                                  </Link>
                                                </span>
                                              </div>
                                              :
                                              <a
                                                className={`collapsed`}
                                                data-bs-toggle="collapse"
                                                href={`#collapseThirdii${i3}`}
                                                aria-expanded="true"
                                                aria-controls={`collapseThirdii${i3}`}
                                              >
                                                {item3.HorseNumber} {" - "}{" "}
                                                {currentLanguage == 'en' ? item3.HorseName : item3.HorseNameAr}
                                              </a>
                                            }
                                          </div>
                                          <div className="panel-title showTableTabHeader  t-center-responsive floatLeftinArabic col-md-2 col-sm-6">
                                            <a
                                              className="collapsed"
                                              data-bs-toggle="collapse"
                                              href={`#collapseThirdii${i3}`}
                                              aria-expanded="false"
                                              aria-controls={`collapseThirdii${i3}`}
                                            >
                                              {item3.TotalScore != 0 ? item3.TotalScore?.toFixed(2) : ''} {!!item3?.Reason && item3?.Reason}
                                            </a>
                                          </div>

                                          <div className="panel-title showTableTabHeader  text-right-rtl floatLeftinArabic col-md-2 col-sm-6">
                                            <div className="panel-title   rtl t-center-responsive showTableTabHeader">
                                              <a
                                                data-bs-toggle="collapse"
                                                href={`#collapseThirdii${i3}`}
                                                aria-expanded="false"
                                                aria-controls={`collapseThirdii${i3}`}
                                                className="text-right rotateUp collapsed "
                                                style={{ padding: "5px 0" }}
                                              >
                                                <span
                                                  style={{
                                                    color: "var(--mainGold)",
                                                  }}
                                                >
                                                  {translate(
                                                    "web.results",
                                                    "RESULTS"
                                                  )}

                                                  <i
                                                    className={
                                                      "fas fa-chevron-down iconScoringDetails ms-2"
                                                    }
                                                    style={{ fontSize: 14 }}
                                                  ></i>

                                                </span>
                                              </a>
                                            </div>
                                          </div>
                                          <div className="panel-title showTableTabHeader  text-right-rtl floatLeftinArabic d-flex justify-content-center align-items-center col-md-1 col-sm-2">
                                            <div className="panel-title   rtl t-center-responsive showTableTabHeader ">
                                              <a
                                                href={`#collapseThirdii${i3}`}
                                                className="text-right rotateUp collapsed "
                                                style={{ padding: "5px 0" }}
                                              >
                                                {item3?.classHorseGallery?.filter(x => x?.imageUrl?.includes('youtube'))?.length > 0 ?
                                                  <i className="fa-solid px-3 d-inline-block fa-film" style={{ cursor: 'pointer' }} onClick={() => showChampionVideo([item3?.classHorseGallery?.filter(x => x?.imageUrl?.includes('youtube'))[0]?.imageUrl])} ></i> : <></>}
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          id={`collapseThirdii${i3}`}
                                          ref={(el) => (collapseRef.current[item3?.HorseId?.toLowerCase()] = el)}
                                          className="panel-collapse collapse"
                                          data-bs-parent="#accordionThirdii"
                                        >
                                          <div className="panel-body position-relative   panelBodyResponsive showssubTable mx-0 row bgdefault">
                                            <div className="col-md-4">
                                              {translate(
                                                "web.birthDate",
                                                "Birth Date"
                                              )}
                                              <div
                                                style={{
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                <p> {item3?.BirthDate} </p>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              {translate(
                                                "web.sire",
                                                "Sire"
                                              )}
                                              <div>
                                                <p>{currentLanguage == 'en' ? item3.Sire : item3.SireAr} </p>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              {translate(
                                                "web.breeder",
                                                "Breeder"
                                              )}
                                              <div>
                                                <p>{currentLanguage == 'en' ? item3.Breeder : item3.BreederAr} </p>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              {translate(
                                                "web.color",
                                                "Color"
                                              )}
                                              <div>
                                                <p>{currentLanguage == 'en' ? item3.Color : item3.ColorAr} </p>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              {translate("web.dam", "Dam")}
                                              <div>
                                                <p>{currentLanguage == 'en' ? item3.Dam : item3.DamAr} </p>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              {translate(
                                                "web.owner",
                                                "Owner"
                                              )}
                                              <div>
                                                <p>{currentLanguage == 'en' ? item3.Owner : item3.OwnerAr} </p>
                                              </div>
                                            </div>
                                            {showClassHorseSoringDetailsData?.classHorseGallery?.filter(x => !x?.imageUrl?.includes('youtube')).length > 0 &&
                                              <div
                                                className="text-end position-absolute top-0 end-0 ms-1 floatLeftinArabic col-md-1 col-sm-6"
                                                style={{ padding: '5px 0' }}
                                                onClick={() => handleHorseMediaClass(showClassHorseSoringDetailsData?.classHorseGallery ?? [])}
                                              >
                                                <button className="p-1 border-0 me-4" title={translate('web.viewImages', 'View Images')} style={{ margin: 0 }}>
                                                  <i
                                                    className="fa-regular fa-images"
                                                    aria-hidden="true"
                                                  ></i>
                                                </button>
                                              </div>
                                            }
                                            {!!item3.TotalScore && data?.at(-1)?.Stage?.toLowerCase() == 'Classes'.toLowerCase() &&
                                              <HorseResultsTable showbyIdData={showbyIdData} showsLoading={showsLoading} showClassHorseSoringDetailsData={showClassHorseSoringDetailsData} item3={item3} />
                                            }
                                            {!!item3.TotalScore && data?.at(-1)?.Stage?.toLowerCase() == 'Championship'.toLowerCase() &&
                                              <>
                                                <table
                                                  className="table table-striped table-bordered"
                                                  style={{
                                                    direction:
                                                      currentLanguage == "ar"
                                                        ? "rtl"
                                                        : "ltr",
                                                  }}
                                                >
                                                  <thead
                                                    className="fw-bold"
                                                    style={{
                                                      color: "white",
                                                    }}
                                                  >
                                                    <tr>
                                                      {championHorseTableHeaderLive?.map(
                                                        (item, i) => (
                                                          <th
                                                            className="text-center"
                                                            key={i}
                                                          >
                                                            {item}
                                                          </th>
                                                        )
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {!!championHorseTableDataLive &&
                                                      !!championHorseTableDataLive &&
                                                      championHorseTableDataLive?.map(
                                                        (item, i) => (
                                                          <tr key={i}>
                                                            {!!item &&
                                                              item?.rowData.map(
                                                                (ele, ind) => (
                                                                  <td className="text-center" key={ind} dangerouslySetInnerHTML={{ __html: ele }} ></td>
                                                                )
                                                              )}
                                                          </tr>
                                                        )
                                                      )}
                                                  </tbody>
                                                </table>
                                              </>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>

                      </div>
                    ) : (
                      <span className="text-danger text-center  rtl text-right-rtl">
                        {translate("web.noClassIsRunningNow", "No Class Is Running Now !")}
                      </span>
                    )}
                  </div>

                </EahsForm>
              </div>
            )}
            {<JudgeList showID={currentId} setFireStoreDataJugdes={setFireStoreDataJugdes} />}
            {/* </div> */}
          </div>
        </div>

        {
          //show judges
        }

        {
          //ChampionShip
        }
      </div>

      {!!showChampionshipCardsData &&
        showChampionshipCardsData.length > 0 &&
        showChampionshipCardsData.filter(
          (item) =>
            !(
              item.goldHorse == null &&
              item.silverHorse == null &&
              item.bronzeHorse == null
            )
        ).length > 0 ? (
        <div className="pt-5">
          <EahsForm key={'champion'} isSectionTitle={true} title={translate("web.championship", "Championship")}>
            {!!showChampionshipCardsData &&
              showChampionshipCardsData.length > 0 ? (
              showChampionshipCardsData.map(
                (item, iShowChampionshipCardsData) =>
                  !(
                    item.goldHorse == null &&
                    item.silverHorse == null &&
                    item.bronzeHorse == null
                  ) && (
                    <div
                      key={iShowChampionshipCardsData}
                      className={showChampionshipCardsData.length > 4 ? "col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-main" : "col-xl-3 col-lg-4 col-md-6 col-sm-12"}
                    >
                      <div className="p-main bg-white border-15 p-3 h-100 border borderf3 homeWhiteBg" >
                        <div className="col-md-12">
                          <span className="horseCardTitle d-flex justify-content-between align-items-center mb-1">{item.championshipName} {!!item?.videoUrl ? <i className="fa-solid ms-auto fa-film " style={{ cursor: 'pointer' }} onClick={() => showChampionVideo([item?.videoUrl])} ></i> : <></>}  </span>
                        </div>
                        <div className="whiteSpacer col-12" />
                        <div
                          className="col-sm-12 mb-main"
                        >
                          {item.goldHorse != null && (
                            <div className="JudgesTableRow">
                              <svg
                                width="30px"
                                height="30px"
                                className=""
                                viewBox="0 0 46 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_3244_95)">
                                  <path
                                    d="M40.6004 19.3333C40.6004 28.9063 32.7206 36.6667 23.0004 36.6667C13.2802 36.6667 5.40039 28.9063 5.40039 19.3333C5.40039 9.7604 13.2802 2 23.0004 2C32.7206 2 40.6004 9.7604 40.6004 19.3333Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M41.9041 19.3333C41.9041 29.6154 33.4406 37.9506 23.0004 37.9506C12.5602 37.9506 4.09668 29.6154 4.09668 19.3333C4.09668 9.0513 12.5602 0.716064 23.0004 0.716064C33.4406 0.716064 41.9041 9.0513 41.9041 19.3333ZM23.0004 36.6667C32.7206 36.6667 40.6004 28.9063 40.6004 19.3333C40.6004 9.76041 32.7206 2.00001 23.0004 2.00001C13.2802 2.00001 5.40038 9.76041 5.40038 19.3333C5.40038 28.9063 13.2802 36.6667 23.0004 36.6667Z"
                                    fill="#E89B05"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.7042 19.9753C6.34419 19.9753 6.05235 19.6879 6.05235 19.3334C6.05235 10.115 13.6403 2.64201 23.0005 2.64201C23.3605 2.64201 23.6523 2.92943 23.6523 3.28399C23.6523 3.63854 23.3605 3.92596 23.0005 3.92596C14.3603 3.92596 7.35605 10.8241 7.35605 19.3334C7.35605 19.6879 7.06421 19.9753 6.7042 19.9753Z"
                                    fill="#E8AA0A"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.2968 18.6913C39.6568 18.6913 39.9486 18.9788 39.9486 19.3333C39.9486 28.5517 32.3607 36.0247 23.0005 36.0247C22.6405 36.0247 22.3486 35.7373 22.3486 35.3827C22.3486 35.0281 22.6405 34.7407 23.0005 34.7407C31.6407 34.7407 38.6449 27.8426 38.6449 19.3333C38.6449 18.9788 38.9368 18.6913 39.2968 18.6913Z"
                                    fill="#E8AA0A"
                                  />
                                  <path
                                    d="M36.037 19.3333C36.037 26.4244 30.2001 32.1728 22.9999 32.1728C15.7998 32.1728 9.96289 26.4244 9.96289 19.3333C9.96289 12.2423 15.7998 6.49384 22.9999 6.49384C30.2001 6.49384 36.037 12.2423 36.037 19.3333Z"
                                    fill="#FFDD28"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M37.3407 19.3334C37.3407 27.1335 30.9201 33.4568 22.9999 33.4568C15.0797 33.4568 8.65918 27.1335 8.65918 19.3334C8.65918 11.5332 15.0797 5.2099 22.9999 5.2099C30.9201 5.2099 37.3407 11.5332 37.3407 19.3334ZM22.9999 32.1729C30.2001 32.1729 36.037 26.4244 36.037 19.3334C36.037 12.2423 30.2001 6.49385 22.9999 6.49385C15.7998 6.49385 9.96288 12.2423 9.96288 19.3334C9.96288 26.4244 15.7998 32.1729 22.9999 32.1729Z"
                                    fill="#E89B05"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.0006 30.2469C29.1207 30.2469 34.082 25.3608 34.082 19.3334C34.082 18.9788 34.3739 18.6914 34.7339 18.6914C35.0939 18.6914 35.3857 18.9788 35.3857 19.3334C35.3857 26.0699 29.8407 31.5309 23.0006 31.5309C22.6406 31.5309 22.3487 31.2435 22.3487 30.8889C22.3487 30.5344 22.6406 30.2469 23.0006 30.2469Z"
                                    fill="#ECC704"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.0004 8.41975C16.8803 8.41975 11.9189 13.3059 11.9189 19.3333C11.9189 19.6879 11.6271 19.9753 11.2671 19.9753C10.9071 19.9753 10.6152 19.6879 10.6152 19.3333C10.6152 12.5968 16.1603 7.1358 23.0004 7.1358C23.3604 7.1358 23.6523 7.42323 23.6523 7.77778C23.6523 8.13233 23.3604 8.41975 23.0004 8.41975Z"
                                    fill="#FFEF9C"
                                  />
                                  <path
                                    d="M3.07736 36.4247L1.39833 33.1175C1.21548 32.7574 1.4814 32.3336 1.89027 32.3336L9.25035 32.3336C9.5541 32.3336 9.80035 32.5761 9.80035 32.8753L9.80035 40.4586C9.80035 40.7578 9.5541 41.0003 9.25035 41.0003L1.89027 41.0003C1.4814 41.0003 1.21548 40.5765 1.39833 40.2164L3.07736 36.9092C3.15478 36.7567 3.15478 36.5772 3.07736 36.4247Z"
                                    fill="#FFDD28"
                                  />
                                  <path
                                    d="M42.9233 36.4247L44.6024 33.1175C44.7852 32.7574 44.5193 32.3336 44.1104 32.3336L36.7503 32.3336C36.4466 32.3336 36.2003 32.5761 36.2003 32.8753L36.2003 40.4586C36.2003 40.7578 36.4466 41.0003 36.7503 41.0003L44.1104 41.0003C44.5193 41.0003 44.7852 40.5765 44.6024 40.2164L42.9233 36.9092C42.8459 36.7567 42.8459 36.5772 42.9233 36.4247Z"
                                    fill="#FFDD28"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M1.96967 36.6669L0.413624 33.602C-0.134914 32.5215 0.662838 31.2502 1.88943 31.2502L9.24951 31.2502C10.1608 31.2502 10.8995 31.9778 10.8995 32.8752L10.8995 40.4586C10.8995 41.356 10.1608 42.0836 9.24951 42.0836L1.88943 42.0836C0.662838 42.0836 -0.134915 40.8123 0.413623 39.7319L1.96967 36.6669ZM2.09234 36.9085C2.09245 36.9087 2.09255 36.909 2.09266 36.9092L2.5846 36.6669L2.09265 36.9091L2.09234 36.9085ZM44.0293 36.6669L45.5854 33.602C46.1339 32.5215 45.3362 31.2502 44.1096 31.2502L36.7495 31.2502C35.8382 31.2502 35.0995 31.9778 35.0995 32.8752L35.0995 40.4586C35.0995 41.356 35.8382 42.0836 36.7495 42.0836L44.1096 42.0836C45.3362 42.0836 46.1339 40.8123 45.5854 39.7319L44.0293 36.6669ZM44.6015 33.1175L42.9225 36.4247C42.8451 36.5772 42.8451 36.7567 42.9225 36.9092L44.6015 40.2163C44.7844 40.5765 44.5184 41.0002 44.1096 41.0002L36.7495 41.0002C36.4458 41.0002 36.1995 40.7577 36.1995 40.4586L36.1995 32.8752C36.1995 32.5761 36.4458 32.3336 36.7495 32.3336L44.1096 32.3336C44.5184 32.3336 44.7844 32.7573 44.6015 33.1175ZM1.3975 33.1175L3.07652 36.4247C3.15395 36.5772 3.15395 36.7567 3.07652 36.9091L1.39749 40.2163C1.21464 40.5765 1.48057 41.0002 1.88943 41.0002L9.24951 41.0002C9.55326 41.0002 9.79951 40.7577 9.79951 40.4586L9.79951 32.8752C9.79951 32.5761 9.55326 32.3336 9.24951 32.3336L1.88943 32.3336C1.48057 32.3336 1.21465 32.7573 1.3975 33.1175Z"
                                    fill="#E89B05"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.18431 32.8234C2.28502 32.666 2.46071 32.5706 2.64961 32.5706H4.98711C5.29087 32.5706 5.53711 32.8131 5.53711 33.1122C5.53711 33.4114 5.29087 33.6539 4.98711 33.6539H3.52232L4.65828 35.9931C4.78934 36.263 4.67344 36.5864 4.39941 36.7155C4.12538 36.8445 3.79699 36.7304 3.66594 36.4605L2.15344 33.3459C2.07193 33.1781 2.08359 32.9808 2.18431 32.8234Z"
                                    fill="#ECC704"
                                  />
                                  <path
                                    d="M38.4004 38.2919L38.4004 30.7086C38.4004 30.4094 38.1541 30.1669 37.8504 30.1669L8.15039 30.1669C7.84663 30.1669 7.60039 30.4094 7.60039 30.7086L7.60039 38.2919C7.60039 38.5911 7.84663 38.8336 8.15039 38.8336L37.8504 38.8336C38.1541 38.8336 38.4004 38.5911 38.4004 38.2919Z"
                                    fill="#FFDD28"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.5 30.7086L39.5 38.292C39.5 39.1894 38.7613 39.9169 37.85 39.9169L8.15 39.9169C7.23873 39.9169 6.5 39.1894 6.5 38.2919L6.5 30.7086C6.5 29.8112 7.23873 29.0836 8.15 29.0836L37.85 29.0836C38.7613 29.0836 39.5 29.8112 39.5 30.7086ZM38.4 30.7086L38.4 38.292C38.4 38.5911 38.1538 38.8336 37.85 38.8336L8.15 38.8336C7.84624 38.8336 7.6 38.5911 7.6 38.2919L7.6 30.7086C7.6 30.4095 7.84624 30.1669 8.15 30.1669L37.85 30.167C38.1538 30.167 38.4 30.4095 38.4 30.7086Z"
                                    fill="#E89B05"
                                  />
                                  <path
                                    d="M36.8814 34.706C36.5699 34.706 36.3175 34.4634 36.3175 34.1641C36.3175 33.8649 36.5699 33.6223 36.8814 33.6223C37.1928 33.6223 37.4453 33.8649 37.4453 34.1641C37.4453 34.4634 37.1928 34.706 36.8814 34.706Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M34.7351 34.4892C34.3477 34.4892 34.0336 34.1874 34.0336 33.8152C34.0336 33.443 34.3477 33.1412 34.7351 33.1412C35.1225 33.1412 35.4365 33.443 35.4365 33.8152C35.4365 34.1874 35.1225 34.4892 34.7351 34.4892Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M35.6913 36.0301C35.4976 36.0301 35.3405 35.8792 35.3405 35.6931C35.3405 35.507 35.4976 35.3561 35.6913 35.3561C35.885 35.3561 36.042 35.507 36.042 35.6931C36.042 35.8792 35.885 36.0301 35.6913 36.0301Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M35.0858 32.4659C34.8921 32.4659 34.7351 32.315 34.7351 32.1289C34.7351 31.9428 34.8921 31.7919 35.0858 31.7919C35.2795 31.7919 35.4365 31.9428 35.4365 32.1289C35.4365 32.315 35.2795 32.4659 35.0858 32.4659Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M33.243 35.6931C33.0493 35.6931 32.8923 35.5423 32.8923 35.3562C32.8923 35.17 33.0493 35.0192 33.243 35.0192C33.4367 35.0192 33.5937 35.17 33.5937 35.3562C33.5937 35.5423 33.4367 35.6931 33.243 35.6931Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M32.8924 33.9593C32.6987 33.9593 32.5417 33.8084 32.5417 33.6223C32.5417 33.4362 32.6987 33.2853 32.8924 33.2853C33.0861 33.2853 33.2432 33.4362 33.2432 33.6223C33.2432 33.8084 33.0861 33.9593 32.8924 33.9593Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M30.5008 37.8684C30.3071 37.8684 30.1501 37.7175 30.1501 37.5314C30.1501 37.3453 30.3071 37.1944 30.5008 37.1944C30.6945 37.1944 30.8516 37.3453 30.8516 37.5314C30.8516 37.7175 30.6945 37.8684 30.5008 37.8684Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M37.4793 36.5819C37.2856 36.5819 37.1286 36.4311 37.1286 36.245C37.1286 36.0588 37.2856 35.908 37.4793 35.908C37.6731 35.908 37.8301 36.0588 37.8301 36.245C37.8301 36.4311 37.6731 36.5819 37.4793 36.5819Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M34.1646 37.32C33.8493 37.32 33.5938 37.0744 33.5938 36.7715C33.5938 36.4686 33.8493 36.2231 34.1646 36.2231C34.4798 36.2231 34.7354 36.4686 34.7354 36.7715C34.7354 37.0744 34.4798 37.32 34.1646 37.32Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M36.6128 37.8684C36.2976 37.8684 36.042 37.6228 36.042 37.3199C36.042 37.017 36.2976 36.7715 36.6128 36.7715C36.928 36.7715 37.1836 37.017 37.1836 37.3199C37.1836 37.6228 36.928 37.8684 36.6128 37.8684Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M31.6196 36.7901C31.3044 36.7901 31.0488 36.5445 31.0488 36.2416C31.0488 35.9387 31.3044 35.6932 31.6196 35.6932C31.9349 35.6932 32.1904 35.9387 32.1904 36.2416C32.1904 36.5445 31.9349 36.7901 31.6196 36.7901Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    d="M32.5418 38.0349C32.3481 38.0349 32.1911 37.884 32.1911 37.6979C32.1911 37.5118 32.3481 37.3609 32.5418 37.3609C32.7356 37.3609 32.8926 37.5118 32.8926 37.6979C32.8926 37.884 32.7356 38.0349 32.5418 38.0349Z"
                                    fill="#FFBB0D"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.94336 30.9456C7.94336 30.6464 8.1896 30.4039 8.49336 30.4039H29.1184C29.4221 30.4039 29.6684 30.6464 29.6684 30.9456C29.6684 31.2448 29.4221 31.4873 29.1184 31.4873H9.04336V35.2789C9.04336 35.5781 8.79712 35.8206 8.49336 35.8206C8.1896 35.8206 7.94336 35.5781 7.94336 35.2789V30.9456Z"
                                    fill="#FFEF9C"
                                  />
                                  <path
                                    d="M24.4095 23.988H22.4089V16.3929L20.0205 17.1224V15.5202L24.1949 14.0475H24.4095V23.988Z"
                                    fill="#FFEF9C"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M25.5908 23.988C25.5908 24.6306 25.0619 25.1516 24.4094 25.1516H22.4087C21.7562 25.1516 21.2272 24.6306 21.2272 23.988V17.972L20.3703 18.2338C20.0118 18.3433 19.6217 18.2785 19.3195 18.0591C19.0173 17.8398 18.8389 17.4921 18.8389 17.1224V15.5202C18.8389 15.0289 19.1522 14.5905 19.6219 14.4248L23.7963 12.9521C23.9242 12.907 24.059 12.884 24.1948 12.884H24.4094C25.0619 12.884 25.5908 13.4049 25.5908 14.0476V23.988ZM22.4087 16.3929V23.988H24.4094V14.0476H24.1948L20.0203 15.5202V17.1224L22.4087 16.3929Z"
                                    fill="#E89B05"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3244_95">
                                    <rect width="46" height="43" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>

                              <div className="showDetailsJudesName horseCardDescription fw-bold  ms-3 ">
                                {windowWidth > 991
                                  ? truncateString(
                                    `${item.goldHorse.horseNumber} - ${item.goldHorse.horseName}`
                                  )
                                  : item.goldHorse.horseNumber +
                                  " - " +
                                  item.goldHorse.horseName}
                              </div>
                            </div>
                          )}
                          {item.silverHorse != null && (
                            <div className="JudgesTableRow">
                              <svg
                                className=""
                                width="30px"
                                height="30px"
                                viewBox="0 0 46 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_3244_162)">
                                  <path
                                    d="M40.6004 19.6C40.6004 29.3202 32.7206 37.2 23.0004 37.2C13.2802 37.2 5.40039 29.3202 5.40039 19.6C5.40039 9.87979 13.2802 2 23.0004 2C32.7206 2 40.6004 9.87979 40.6004 19.6Z"
                                    fill="#BCCCD2"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M41.9041 19.6C41.9041 30.0402 33.4406 38.5037 23.0004 38.5037C12.5602 38.5037 4.09668 30.0402 4.09668 19.6C4.09668 9.15976 12.5602 0.696289 23.0004 0.696289C33.4406 0.696289 41.9041 9.15976 41.9041 19.6ZM23.0004 37.2C32.7206 37.2 40.6004 29.3202 40.6004 19.6C40.6004 9.87978 32.7206 1.99999 23.0004 1.99999C13.2802 1.99999 5.40038 9.87978 5.40038 19.6C5.40038 29.3202 13.2802 37.2 23.0004 37.2Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.7042 20.2518C6.34419 20.2518 6.05234 19.96 6.05234 19.6C6.05234 10.2398 13.6403 2.65183 23.0005 2.65183C23.3605 2.65183 23.6523 2.94368 23.6523 3.30368C23.6523 3.66369 23.3605 3.95554 23.0005 3.95554C14.3603 3.95554 7.35605 10.9598 7.35605 19.6C7.35605 19.96 7.0642 20.2518 6.7042 20.2518Z"
                                    fill="#D0DEE3"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.2968 18.9481C39.6568 18.9481 39.9486 19.24 39.9486 19.6C39.9486 28.9602 32.3607 36.5481 23.0005 36.5481C22.6405 36.5481 22.3486 36.2563 22.3486 35.8963C22.3486 35.5363 22.6405 35.2444 23.0005 35.2444C31.6407 35.2444 38.6449 28.2402 38.6449 19.6C38.6449 19.24 38.9368 18.9481 39.2968 18.9481Z"
                                    fill="#A2B9C1"
                                  />
                                  <path
                                    d="M36.037 19.6C36.037 26.8002 30.2001 32.6371 22.9999 32.6371C15.7998 32.6371 9.96289 26.8002 9.96289 19.6C9.96289 12.3999 15.7998 6.56299 22.9999 6.56299C30.2001 6.56299 36.037 12.3999 36.037 19.6Z"
                                    fill="#C7D4D8"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M37.3407 19.6C37.3407 27.5202 30.9201 33.9408 22.9999 33.9408C15.0797 33.9408 8.65918 27.5202 8.65918 19.6C8.65918 11.6798 15.0797 5.25928 22.9999 5.25928C30.9201 5.25928 37.3407 11.6798 37.3407 19.6ZM22.9999 32.6371C30.2001 32.6371 36.037 26.8002 36.037 19.6C36.037 12.3999 30.2001 6.56298 22.9999 6.56298C15.7998 6.56298 9.96288 12.3999 9.96288 19.6C9.96288 26.8002 15.7998 32.6371 22.9999 32.6371Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.0006 30.6815C29.1207 30.6815 34.082 25.7201 34.082 19.6C34.082 19.24 34.3739 18.9481 34.7339 18.9481C35.0939 18.9481 35.3857 19.24 35.3857 19.6C35.3857 26.4401 29.8407 31.9852 23.0006 31.9852C22.6405 31.9852 22.3487 31.6933 22.3487 31.3333C22.3487 30.9733 22.6405 30.6815 23.0006 30.6815Z"
                                    fill="#B5C3C8"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.0004 8.51855C16.8803 8.51855 11.9189 13.4799 11.9189 19.6C11.9189 19.96 11.6271 20.2519 11.2671 20.2519C10.9071 20.2519 10.6152 19.96 10.6152 19.6C10.6152 12.7599 16.1603 7.21484 23.0004 7.21484C23.3604 7.21484 23.6523 7.50669 23.6523 7.8667C23.6523 8.2267 23.3604 8.51855 23.0004 8.51855Z"
                                    fill="#D9EAEF"
                                  />
                                  <path
                                    d="M3.07736 36.954L1.39833 33.596C1.21548 33.2303 1.4814 32.8 1.89027 32.8L9.25035 32.8C9.5541 32.8 9.80035 33.0462 9.80035 33.35L9.80035 41.05C9.80035 41.3537 9.5541 41.6 9.25035 41.6L1.89027 41.6C1.4814 41.6 1.21548 41.1697 1.39833 40.804L3.07736 37.446C3.15478 37.2911 3.15478 37.1089 3.07736 36.954Z"
                                    fill="#C7D4D8"
                                  />
                                  <path
                                    d="M42.9233 36.954L44.6024 33.596C44.7852 33.2303 44.5193 32.8 44.1104 32.8L36.7503 32.8C36.4466 32.8 36.2003 33.0462 36.2003 33.35L36.2003 41.05C36.2003 41.3537 36.4466 41.6 36.7503 41.6L44.1104 41.6C44.5193 41.6 44.7852 41.1697 44.6024 40.804L42.9233 37.446C42.8459 37.2911 42.8459 37.1089 42.9233 36.954Z"
                                    fill="#C7D4D8"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M1.96967 37.1999L0.413624 34.0879C-0.134914 32.9908 0.662838 31.6999 1.88943 31.6999L9.24951 31.6999C10.1608 31.6999 10.8995 32.4387 10.8995 33.35L10.8995 41.05C10.8995 41.9612 10.1608 42.6999 9.24951 42.6999L1.88943 42.6999C0.662838 42.6999 -0.134915 41.4091 0.413623 40.312L1.96967 37.1999ZM2.09234 37.4453C2.09245 37.4455 2.09255 37.4457 2.09266 37.4459L2.5846 37.1999L2.09265 37.4459L2.09234 37.4453ZM44.0293 37.2L45.5854 34.0879C46.1339 32.9908 45.3362 31.7 44.1096 31.7L36.7495 31.7C35.8382 31.7 35.0995 32.4387 35.0995 33.35L35.0995 41.05C35.0995 41.9612 35.8382 42.7 36.7495 42.7L44.1096 42.7C45.3362 42.7 46.1339 41.4091 45.5854 40.312L44.0293 37.2ZM44.6015 33.5959L42.9225 36.954C42.8451 37.1088 42.8451 37.2911 42.9225 37.4459L44.6015 40.804C44.7844 41.1697 44.5184 41.6 44.1096 41.6L36.7495 41.6C36.4458 41.6 36.1995 41.3537 36.1995 41.05L36.1995 33.35C36.1995 33.0462 36.4458 32.8 36.7495 32.8L44.1096 32.8C44.5184 32.8 44.7844 33.2302 44.6015 33.5959ZM1.3975 33.5959L3.07652 36.954C3.15395 37.1088 3.15395 37.2911 3.07652 37.4459L1.39749 40.804C1.21464 41.1697 1.48057 41.5999 1.88943 41.5999L9.24951 41.6C9.55326 41.6 9.79951 41.3537 9.79951 41.0499L9.79951 33.35C9.79951 33.0462 9.55326 32.7999 9.24951 32.7999L1.88943 32.7999C1.48057 32.7999 1.21465 33.2302 1.3975 33.5959Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.18431 33.2973C2.28502 33.1375 2.46071 33.0406 2.64961 33.0406H4.98711C5.29087 33.0406 5.53711 33.2868 5.53711 33.5906C5.53711 33.8943 5.29087 34.1406 4.98711 34.1406H3.52232L4.65828 36.5158C4.78934 36.7898 4.67344 37.1182 4.39941 37.2493C4.12538 37.3803 3.79699 37.2644 3.66594 36.9904L2.15344 33.8279C2.07193 33.6575 2.08359 33.4572 2.18431 33.2973Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M38.4004 38.85L38.4004 31.15C38.4004 30.8462 38.1541 30.6 37.8504 30.6L8.15039 30.6C7.84663 30.6 7.60039 30.8462 7.60039 31.15L7.60039 38.85C7.60039 39.1537 7.84663 39.4 8.15039 39.4L37.8504 39.4C38.1541 39.4 38.4004 39.1537 38.4004 38.85Z"
                                    fill="#C7D4D8"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.5 31.15L39.5 38.85C39.5 39.7613 38.7613 40.5 37.85 40.5L8.15 40.5C7.23873 40.5 6.5 39.7613 6.5 38.85L6.5 31.15C6.5 30.2387 7.23873 29.5 8.15 29.5L37.85 29.5C38.7613 29.5 39.5 30.2387 39.5 31.15ZM38.4 31.15L38.4 38.85C38.4 39.1538 38.1538 39.4 37.85 39.4L8.15 39.4C7.84624 39.4 7.6 39.1538 7.6 38.85L7.6 31.15C7.6 30.8462 7.84624 30.6 8.15 30.6L37.85 30.6C38.1538 30.6 38.4 30.8462 38.4 31.15Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M36.8814 35.2089C36.5699 35.2089 36.3175 34.9625 36.3175 34.6587C36.3175 34.3548 36.5699 34.1085 36.8814 34.1085C37.1928 34.1085 37.4453 34.3548 37.4453 34.6587C37.4453 34.9625 37.1928 35.2089 36.8814 35.2089Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M34.7351 34.9888C34.3477 34.9888 34.0336 34.6824 34.0336 34.3044C34.0336 33.9265 34.3477 33.6201 34.7351 33.6201C35.1225 33.6201 35.4365 33.9265 35.4365 34.3044C35.4365 34.6824 35.1225 34.9888 34.7351 34.9888Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M35.6913 36.5534C35.4976 36.5534 35.3405 36.4002 35.3405 36.2113C35.3405 36.0223 35.4976 35.8691 35.6913 35.8691C35.885 35.8691 36.042 36.0223 36.042 36.2113C36.042 36.4002 35.885 36.5534 35.6913 36.5534Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M35.0858 32.9344C34.8921 32.9344 34.7351 32.7812 34.7351 32.5922C34.7351 32.4032 34.8921 32.25 35.0858 32.25C35.2795 32.25 35.4365 32.4032 35.4365 32.5922C35.4365 32.7812 35.2795 32.9344 35.0858 32.9344Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M33.243 36.2112C33.0493 36.2112 32.8923 36.058 32.8923 35.869C32.8923 35.6801 33.0493 35.5269 33.243 35.5269C33.4367 35.5269 33.5937 35.6801 33.5937 35.869C33.5937 36.058 33.4367 36.2112 33.243 36.2112Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M32.8924 34.4507C32.6987 34.4507 32.5417 34.2975 32.5417 34.1085C32.5417 33.9196 32.6987 33.7664 32.8924 33.7664C33.0861 33.7664 33.2432 33.9196 33.2432 34.1085C33.2432 34.2975 33.0861 34.4507 32.8924 34.4507Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M30.5008 38.4199C30.3071 38.4199 30.1501 38.2668 30.1501 38.0778C30.1501 37.8888 30.3071 37.7356 30.5008 37.7356C30.6945 37.7356 30.8516 37.8888 30.8516 38.0778C30.8516 38.2668 30.6945 38.4199 30.5008 38.4199Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M37.4793 37.1137C37.2856 37.1137 37.1286 36.9605 37.1286 36.7715C37.1286 36.5825 37.2856 36.4293 37.4793 36.4293C37.6731 36.4293 37.8301 36.5825 37.8301 36.7715C37.8301 36.9605 37.6731 37.1137 37.4793 37.1137Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M34.1646 37.8631C33.8493 37.8631 33.5938 37.6138 33.5938 37.3062C33.5938 36.9987 33.8493 36.7493 34.1646 36.7493C34.4798 36.7493 34.7354 36.9987 34.7354 37.3062C34.7354 37.6138 34.4798 37.8631 34.1646 37.8631Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M36.6128 38.4199C36.2976 38.4199 36.042 38.1706 36.042 37.863C36.042 37.5555 36.2976 37.3062 36.6128 37.3062C36.928 37.3062 37.1836 37.5555 37.1836 37.863C37.1836 38.1706 36.928 38.4199 36.6128 38.4199Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M31.6196 37.325C31.3044 37.325 31.0488 37.0757 31.0488 36.7681C31.0488 36.4606 31.3044 36.2112 31.6196 36.2112C31.9349 36.2112 32.1904 36.4606 32.1904 36.7681C32.1904 37.0757 31.9349 37.325 31.6196 37.325Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    d="M32.5418 38.589C32.3481 38.589 32.1911 38.4358 32.1911 38.2468C32.1911 38.0579 32.3481 37.9047 32.5418 37.9047C32.7356 37.9047 32.8926 38.0579 32.8926 38.2468C32.8926 38.4358 32.7356 38.589 32.5418 38.589Z"
                                    fill="#81A5B0"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.94336 31.3906C7.94336 31.0868 8.1896 30.8406 8.49336 30.8406H29.1184C29.4221 30.8406 29.6684 31.0868 29.6684 31.3906C29.6684 31.6943 29.4221 31.9406 29.1184 31.9406H9.04336V35.7906C9.04336 36.0943 8.79712 36.3406 8.49336 36.3406C8.1896 36.3406 7.94336 36.0943 7.94336 35.7906V31.3906Z"
                                    fill="#D9EAEF"
                                  />
                                  <path
                                    d="M26.4593 24.3259H19.5504V22.9552L22.811 19.48C23.2587 18.9908 23.5886 18.5639 23.8009 18.1993C24.0178 17.8347 24.1263 17.4886 24.1263 17.1609C24.1263 16.7132 24.0132 16.3625 23.7871 16.1086C23.5609 15.8502 23.2379 15.721 22.8179 15.721C22.3656 15.721 22.0079 15.8779 21.7449 16.1917C21.4864 16.5009 21.3572 16.9094 21.3572 17.417H19.3496C19.3496 16.8032 19.495 16.2425 19.7857 15.7348C20.0811 15.2271 20.4965 14.8302 21.0318 14.5441C21.5672 14.2533 22.1741 14.108 22.8525 14.108C23.8909 14.108 24.6963 14.3572 25.2686 14.8556C25.8454 15.3541 26.1339 16.0579 26.1339 16.9671C26.1339 17.4655 26.0047 17.9732 25.7462 18.4901C25.4878 19.007 25.0447 19.6092 24.4171 20.2969L22.1256 22.7129H26.4593V24.3259Z"
                                    fill="#D9EAEF"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M27.6406 24.326C27.6406 24.9785 27.1116 25.5074 26.4591 25.5074H19.5502C18.8977 25.5074 18.3687 24.9785 18.3687 24.326V22.9553C18.3687 22.6549 18.4831 22.3659 18.6886 22.1469L21.944 18.6771C22.3604 18.2217 22.6274 17.8665 22.7798 17.6048L22.7854 17.5953C22.925 17.3607 22.9447 17.222 22.9447 17.1609C22.9447 17.0347 22.9285 16.9608 22.9168 16.9246C22.9149 16.9184 22.913 16.9133 22.9113 16.9091C22.8924 16.9058 22.8621 16.9025 22.8177 16.9025C22.7294 16.9025 22.6923 16.9174 22.6849 16.9206C22.6803 16.9227 22.6771 16.9246 22.6737 16.9272C22.6701 16.9299 22.6623 16.9364 22.6507 16.9501C22.612 16.9967 22.5385 17.114 22.5385 17.4171C22.5385 18.0696 22.0096 18.5985 21.357 18.5985H19.3495C18.6969 18.5985 18.168 18.0696 18.168 17.4171C18.168 16.6078 18.3621 15.843 18.7603 15.1477L18.7643 15.1407C19.1731 14.4381 19.751 13.8897 20.4713 13.504C21.1978 13.1102 22.0011 12.9265 22.8524 12.9265C24.0698 12.9265 25.1874 13.2193 26.0426 13.9632C26.9283 14.7294 27.3152 15.788 27.3152 16.9671C27.3152 17.6761 27.1302 18.3637 26.8028 19.0185C26.4752 19.6736 25.9517 20.368 25.2895 21.0934C25.2845 21.099 25.2793 21.1045 25.2741 21.11L24.8744 21.5315H26.4591C27.1116 21.5315 27.6406 22.0604 27.6406 22.713V24.326ZM22.1255 22.713L24.4169 20.2969C25.0446 19.6093 25.4876 19.007 25.7461 18.4901C26.0045 17.9732 26.1337 17.4655 26.1337 16.9671C26.1337 16.0579 25.8453 15.3541 25.2684 14.8557C24.6961 14.3572 23.8908 14.108 22.8524 14.108C22.1739 14.108 21.567 14.2534 21.0317 14.5441C20.4963 14.8303 20.081 15.2272 19.7856 15.7348C19.6931 15.8964 19.6153 16.0633 19.5522 16.2356C19.417 16.6047 19.3495 16.9986 19.3495 17.4171H21.357C21.357 16.9094 21.4863 16.501 21.7447 16.1917C22.0078 15.8779 22.3655 15.721 22.8177 15.721C23.2377 15.721 23.5608 15.8502 23.7869 16.1087C24.0131 16.3625 24.1261 16.7133 24.1261 17.1609C24.1261 17.4886 24.0177 17.8347 23.8008 18.1993C23.5885 18.5639 23.2585 18.9908 22.8108 19.48L19.5502 22.9553V24.326H26.4591V22.713H22.1255Z"
                                    fill="#81A5B0"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3244_162">
                                    <rect width="46" height="43" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>

                              <div className="showDetailsJudesName horseCardDescription fw-bold ms-3">
                                {windowWidth > 991
                                  ? truncateString(
                                    `${item.silverHorse.horseNumber} - ${item.silverHorse.horseName}`
                                  )
                                  : item.silverHorse.horseNumber +
                                  " - " +
                                  item.silverHorse.horseName}
                              </div>
                            </div>
                          )}
                          {item.bronzeHorse != null && (
                            <div className="JudgesTableRow">
                              <svg
                                className=""
                                width="30px"
                                height="30px"
                                viewBox="0 0 46 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_3244_228)">
                                  <path
                                    d="M40.6004 19.6C40.6004 29.3202 32.7206 37.2 23.0004 37.2C13.2802 37.2 5.40039 29.3202 5.40039 19.6C5.40039 9.87979 13.2802 2 23.0004 2C32.7206 2 40.6004 9.87979 40.6004 19.6Z"
                                    fill="#DCA16A"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M41.9041 19.6C41.9041 30.0402 33.4406 38.5037 23.0004 38.5037C12.5602 38.5037 4.09668 30.0402 4.09668 19.6C4.09668 9.15976 12.5602 0.696289 23.0004 0.696289C33.4406 0.696289 41.9041 9.15976 41.9041 19.6ZM23.0004 37.2C32.7206 37.2 40.6004 29.3202 40.6004 19.6C40.6004 9.87978 32.7206 1.99999 23.0004 1.99999C13.2802 1.99999 5.40038 9.87978 5.40038 19.6C5.40038 29.3202 13.2802 37.2 23.0004 37.2Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.7042 20.2518C6.34419 20.2518 6.05234 19.96 6.05234 19.6C6.05234 10.2398 13.6403 2.65183 23.0005 2.65183C23.3605 2.65183 23.6523 2.94368 23.6523 3.30368C23.6523 3.66369 23.3605 3.95554 23.0005 3.95554C14.3603 3.95554 7.35605 10.9598 7.35605 19.6C7.35605 19.96 7.0642 20.2518 6.7042 20.2518Z"
                                    fill="#F0B57F"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.2968 18.9481C39.6568 18.9481 39.9486 19.24 39.9486 19.6C39.9486 28.9602 32.3607 36.5481 23.0005 36.5481C22.6405 36.5481 22.3486 36.2563 22.3486 35.8963C22.3486 35.5363 22.6405 35.2444 23.0005 35.2444C31.6407 35.2444 38.6449 28.2402 38.6449 19.6C38.6449 19.24 38.9368 18.9481 39.2968 18.9481Z"
                                    fill="#CF945D"
                                  />
                                  <path
                                    d="M36.037 19.6C36.037 26.8002 30.2001 32.6371 22.9999 32.6371C15.7998 32.6371 9.96289 26.8002 9.96289 19.6C9.96289 12.3999 15.7998 6.56299 22.9999 6.56299C30.2001 6.56299 36.037 12.3999 36.037 19.6Z"
                                    fill="#F7BA82"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M37.3407 19.6C37.3407 27.5202 30.9201 33.9408 22.9999 33.9408C15.0797 33.9408 8.65918 27.5202 8.65918 19.6C8.65918 11.6798 15.0797 5.25928 22.9999 5.25928C30.9201 5.25928 37.3407 11.6798 37.3407 19.6ZM22.9999 32.6371C30.2001 32.6371 36.037 26.8002 36.037 19.6C36.037 12.3999 30.2001 6.56298 22.9999 6.56298C15.7998 6.56298 9.96288 12.3999 9.96288 19.6C9.96288 26.8002 15.7998 32.6371 22.9999 32.6371Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.0006 30.6815C29.1207 30.6815 34.082 25.7201 34.082 19.6C34.082 19.24 34.3739 18.9481 34.7339 18.9481C35.0939 18.9481 35.3857 19.24 35.3857 19.6C35.3857 26.4401 29.8407 31.9852 23.0006 31.9852C22.6405 31.9852 22.3487 31.6933 22.3487 31.3333C22.3487 30.9733 22.6405 30.6815 23.0006 30.6815Z"
                                    fill="#E6A66C"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.0004 8.51855C16.8803 8.51855 11.9189 13.4799 11.9189 19.6C11.9189 19.96 11.6271 20.2519 11.2671 20.2519C10.9071 20.2519 10.6152 19.96 10.6152 19.6C10.6152 12.7599 16.1603 7.21484 23.0004 7.21484C23.3604 7.21484 23.6523 7.50669 23.6523 7.8667C23.6523 8.2267 23.3604 8.51855 23.0004 8.51855Z"
                                    fill="#FFD5AE"
                                  />
                                  <path
                                    d="M3.07736 36.954L1.39833 33.596C1.21548 33.2303 1.4814 32.8 1.89027 32.8L9.25035 32.8C9.5541 32.8 9.80035 33.0462 9.80035 33.35L9.80035 41.05C9.80035 41.3537 9.5541 41.6 9.25035 41.6L1.89027 41.6C1.4814 41.6 1.21548 41.1697 1.39833 40.804L3.07736 37.446C3.15478 37.2911 3.15478 37.1089 3.07736 36.954Z"
                                    fill="#F7BA82"
                                  />
                                  <path
                                    d="M42.9233 36.954L44.6024 33.596C44.7852 33.2303 44.5193 32.8 44.1104 32.8L36.7503 32.8C36.4466 32.8 36.2003 33.0462 36.2003 33.35L36.2003 41.05C36.2003 41.3537 36.4466 41.6 36.7503 41.6L44.1104 41.6C44.5193 41.6 44.7852 41.1697 44.6024 40.804L42.9233 37.446C42.8459 37.2911 42.8459 37.1089 42.9233 36.954Z"
                                    fill="#F7BA82"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M1.96967 37.1999L0.413624 34.0879C-0.134914 32.9908 0.662838 31.6999 1.88943 31.6999L9.24951 31.6999C10.1608 31.6999 10.8995 32.4387 10.8995 33.35L10.8995 41.05C10.8995 41.9612 10.1608 42.6999 9.24951 42.6999L1.88943 42.6999C0.662838 42.6999 -0.134915 41.4091 0.413623 40.312L1.96967 37.1999ZM2.09234 37.4453C2.09245 37.4455 2.09255 37.4457 2.09266 37.4459L2.5846 37.1999L2.09265 37.4459L2.09234 37.4453ZM44.0293 37.2L45.5854 34.0879C46.1339 32.9908 45.3362 31.7 44.1096 31.7L36.7495 31.7C35.8382 31.7 35.0995 32.4387 35.0995 33.35L35.0995 41.05C35.0995 41.9612 35.8382 42.7 36.7495 42.7L44.1096 42.7C45.3362 42.7 46.1339 41.4091 45.5854 40.312L44.0293 37.2ZM44.6015 33.5959L42.9225 36.954C42.8451 37.1088 42.8451 37.2911 42.9225 37.4459L44.6015 40.804C44.7844 41.1697 44.5184 41.6 44.1096 41.6L36.7495 41.6C36.4458 41.6 36.1995 41.3537 36.1995 41.05L36.1995 33.35C36.1995 33.0462 36.4458 32.8 36.7495 32.8L44.1096 32.8C44.5184 32.8 44.7844 33.2302 44.6015 33.5959ZM1.3975 33.5959L3.07652 36.954C3.15395 37.1088 3.15395 37.2911 3.07652 37.4459L1.39749 40.804C1.21464 41.1697 1.48057 41.5999 1.88943 41.5999L9.24951 41.6C9.55326 41.6 9.79951 41.3537 9.79951 41.0499L9.79951 33.35C9.79951 33.0462 9.55326 32.7999 9.24951 32.7999L1.88943 32.7999C1.48057 32.7999 1.21465 33.2302 1.3975 33.5959Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.18431 33.2973C2.28502 33.1375 2.46071 33.0406 2.64961 33.0406H4.98711C5.29087 33.0406 5.53711 33.2868 5.53711 33.5906C5.53711 33.8943 5.29087 34.1406 4.98711 34.1406H3.52232L4.65828 36.5158C4.78934 36.7898 4.67344 37.1182 4.39941 37.2493C4.12538 37.3803 3.79699 37.2644 3.66594 36.9904L2.15344 33.8279C2.07193 33.6575 2.08359 33.4572 2.18431 33.2973Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M38.4004 38.85L38.4004 31.15C38.4004 30.8462 38.1541 30.6 37.8504 30.6L8.15039 30.6C7.84663 30.6 7.60039 30.8462 7.60039 31.15L7.60039 38.85C7.60039 39.1537 7.84663 39.4 8.15039 39.4L37.8504 39.4C38.1541 39.4 38.4004 39.1537 38.4004 38.85Z"
                                    fill="#F7BA82"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M39.5 31.15L39.5 38.85C39.5 39.7613 38.7613 40.5 37.85 40.5L8.15 40.5C7.23873 40.5 6.5 39.7613 6.5 38.85L6.5 31.15C6.5 30.2387 7.23873 29.5 8.15 29.5L37.85 29.5C38.7613 29.5 39.5 30.2387 39.5 31.15ZM38.4 31.15L38.4 38.85C38.4 39.1538 38.1538 39.4 37.85 39.4L8.15 39.4C7.84624 39.4 7.6 39.1538 7.6 38.85L7.6 31.15C7.6 30.8462 7.84624 30.6 8.15 30.6L37.85 30.6C38.1538 30.6 38.4 30.8462 38.4 31.15Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M36.8814 35.2089C36.5699 35.2089 36.3175 34.9625 36.3175 34.6587C36.3175 34.3548 36.5699 34.1085 36.8814 34.1085C37.1928 34.1085 37.4453 34.3548 37.4453 34.6587C37.4453 34.9625 37.1928 35.2089 36.8814 35.2089Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M34.7351 34.9888C34.3477 34.9888 34.0336 34.6824 34.0336 34.3044C34.0336 33.9265 34.3477 33.6201 34.7351 33.6201C35.1225 33.6201 35.4365 33.9265 35.4365 34.3044C35.4365 34.6824 35.1225 34.9888 34.7351 34.9888Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M35.6913 36.5534C35.4976 36.5534 35.3405 36.4002 35.3405 36.2113C35.3405 36.0223 35.4976 35.8691 35.6913 35.8691C35.885 35.8691 36.042 36.0223 36.042 36.2113C36.042 36.4002 35.885 36.5534 35.6913 36.5534Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M35.0858 32.9344C34.8921 32.9344 34.7351 32.7812 34.7351 32.5922C34.7351 32.4032 34.8921 32.25 35.0858 32.25C35.2795 32.25 35.4365 32.4032 35.4365 32.5922C35.4365 32.7812 35.2795 32.9344 35.0858 32.9344Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M33.243 36.2112C33.0493 36.2112 32.8923 36.058 32.8923 35.869C32.8923 35.6801 33.0493 35.5269 33.243 35.5269C33.4367 35.5269 33.5937 35.6801 33.5937 35.869C33.5937 36.058 33.4367 36.2112 33.243 36.2112Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M32.8924 34.4507C32.6987 34.4507 32.5417 34.2975 32.5417 34.1085C32.5417 33.9196 32.6987 33.7664 32.8924 33.7664C33.0861 33.7664 33.2432 33.9196 33.2432 34.1085C33.2432 34.2975 33.0861 34.4507 32.8924 34.4507Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M30.5008 38.4199C30.3071 38.4199 30.1501 38.2668 30.1501 38.0778C30.1501 37.8888 30.3071 37.7356 30.5008 37.7356C30.6945 37.7356 30.8516 37.8888 30.8516 38.0778C30.8516 38.2668 30.6945 38.4199 30.5008 38.4199Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M37.4793 37.1137C37.2856 37.1137 37.1286 36.9605 37.1286 36.7715C37.1286 36.5825 37.2856 36.4293 37.4793 36.4293C37.6731 36.4293 37.8301 36.5825 37.8301 36.7715C37.8301 36.9605 37.6731 37.1137 37.4793 37.1137Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M34.1646 37.8631C33.8493 37.8631 33.5938 37.6138 33.5938 37.3062C33.5938 36.9987 33.8493 36.7493 34.1646 36.7493C34.4798 36.7493 34.7354 36.9987 34.7354 37.3062C34.7354 37.6138 34.4798 37.8631 34.1646 37.8631Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M36.6128 38.4199C36.2976 38.4199 36.042 38.1706 36.042 37.863C36.042 37.5555 36.2976 37.3062 36.6128 37.3062C36.928 37.3062 37.1836 37.5555 37.1836 37.863C37.1836 38.1706 36.928 38.4199 36.6128 38.4199Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M31.6196 37.325C31.3044 37.325 31.0488 37.0757 31.0488 36.7681C31.0488 36.4606 31.3044 36.2112 31.6196 36.2112C31.9349 36.2112 32.1904 36.4606 32.1904 36.7681C32.1904 37.0757 31.9349 37.325 31.6196 37.325Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    d="M32.5418 38.589C32.3481 38.589 32.1911 38.4358 32.1911 38.2468C32.1911 38.0579 32.3481 37.9047 32.5418 37.9047C32.7356 37.9047 32.8926 38.0579 32.8926 38.2468C32.8926 38.4358 32.7356 38.589 32.5418 38.589Z"
                                    fill="#C38144"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.94336 31.3906C7.94336 31.0868 8.1896 30.8406 8.49336 30.8406H29.1184C29.4221 30.8406 29.6684 31.0868 29.6684 31.3906C29.6684 31.6943 29.4221 31.9406 29.1184 31.9406H9.04336V35.7906C9.04336 36.0943 8.79712 36.3406 8.49336 36.3406C8.1896 36.3406 7.94336 36.0943 7.94336 35.7906V31.3906Z"
                                    fill="#FFD5AE"
                                  />
                                  <path
                                    d="M21.5852 18.4001H22.6513C23.159 18.4001 23.5351 18.2732 23.7797 18.0193C24.0243 17.7655 24.1466 17.4286 24.1466 17.0086C24.1466 16.6025 24.0243 16.2863 23.7797 16.0602C23.5397 15.834 23.2074 15.721 22.7828 15.721C22.3998 15.721 22.079 15.8271 21.8206 16.0394C21.5621 16.2471 21.4329 16.5194 21.4329 16.8563H19.4322C19.4322 16.3302 19.573 15.8594 19.8545 15.4441C20.1407 15.0241 20.5376 14.6964 21.0452 14.461C21.5575 14.2257 22.1206 14.108 22.7344 14.108C23.8005 14.108 24.6358 14.3641 25.2404 14.8764C25.845 15.3841 26.1473 16.0856 26.1473 16.9809C26.1473 17.4424 26.0065 17.867 25.725 18.2547C25.4435 18.6424 25.0743 18.94 24.6174 19.1477C25.185 19.3508 25.6073 19.6554 25.8842 20.0615C26.1657 20.4677 26.3065 20.9476 26.3065 21.5015C26.3065 22.3968 25.9788 23.1145 25.3235 23.6544C24.6727 24.1944 23.8097 24.4644 22.7344 24.4644C21.7283 24.4644 20.9045 24.199 20.263 23.6683C19.6261 23.1375 19.3076 22.436 19.3076 21.5638H21.3083C21.3083 21.9422 21.4491 22.2514 21.7306 22.4914C22.0167 22.7314 22.3675 22.8514 22.7828 22.8514C23.2582 22.8514 23.6297 22.7268 23.8974 22.4776C24.1697 22.2237 24.3058 21.8891 24.3058 21.4738C24.3058 20.4677 23.752 19.9646 22.6444 19.9646H21.5852V18.4001Z"
                                    fill="#FFD5AE"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M20.4601 18.0378H19.4321C18.7796 18.0378 18.2506 17.5088 18.2506 16.8563C18.2506 16.106 18.4556 15.402 18.8763 14.7812L18.878 14.7788C19.2962 14.165 19.867 13.705 20.5481 13.3892L20.5518 13.3875C21.2321 13.0749 21.9654 12.9265 22.7342 12.9265C23.982 12.9265 25.1204 13.2273 26.002 13.9733C26.9103 14.737 27.3286 15.7899 27.3286 16.9809C27.3286 17.7018 27.103 18.3677 26.6808 18.949C26.6535 18.9866 26.6256 19.0236 26.5972 19.06C26.6901 19.1639 26.7771 19.2745 26.8576 19.3921C27.2907 20.0186 27.4878 20.7388 27.4878 21.5015C27.4878 22.727 27.0195 23.787 26.0763 24.5649C25.1615 25.3233 24.0079 25.6459 22.7342 25.6459C21.5127 25.6459 20.4047 25.3192 19.5097 24.5786L19.5064 24.5759C18.5845 23.8076 18.126 22.7657 18.126 21.5638C18.126 20.9113 18.6549 20.3823 19.3075 20.3823H20.4795C20.4304 20.2525 20.4036 20.1117 20.4036 19.9646V18.4001C20.4036 18.2737 20.4234 18.152 20.4601 18.0378ZM22.4137 21.1461C22.4627 21.276 22.4896 21.4167 22.4896 21.5638C22.4896 21.5736 22.49 21.5812 22.4905 21.5867C22.4915 21.5876 22.4926 21.5885 22.4937 21.5896C22.5429 21.6298 22.6164 21.6699 22.7827 21.6699C22.9189 21.6699 23.0001 21.6519 23.0421 21.6378C23.0771 21.6261 23.0886 21.6161 23.0916 21.6134M22.4137 21.1461H22.6442C22.9379 21.1461 23.0575 21.1966 23.0902 21.2141C23.0909 21.2159 23.0918 21.2181 23.0927 21.2206C23.1037 21.2507 23.1242 21.3276 23.1242 21.4738C23.1242 21.5515 23.1118 21.5847 23.1092 21.591C23.1076 21.5949 23.1064 21.5968 23.1053 21.5984C23.1042 21.6 23.1002 21.6053 23.0916 21.6134M25.3233 23.6545C25.9787 23.1145 26.3064 22.3968 26.3064 21.5015C26.3064 20.9477 26.1656 20.4677 25.8841 20.0616C25.8385 19.9947 25.7889 19.9306 25.7355 19.8692C25.4642 19.5579 25.0914 19.3174 24.6172 19.1478C25.0446 18.9535 25.3952 18.6805 25.6691 18.3288C25.6881 18.3045 25.7066 18.2798 25.7248 18.2547C26.0064 17.867 26.1471 17.4424 26.1471 16.9809C26.1471 16.0856 25.8448 15.3841 25.2402 14.8764C24.6357 14.3641 23.8003 14.108 22.7342 14.108C22.1204 14.108 21.5573 14.2257 21.0451 14.4611C20.5374 14.6964 20.1405 15.0241 19.8544 15.4441C19.8034 15.5192 19.7571 15.5961 19.7154 15.6748C19.5265 16.0315 19.4321 16.4253 19.4321 16.8563H21.4327C21.4327 16.5194 21.562 16.2471 21.8204 16.0394C22.0789 15.8271 22.3996 15.721 22.7827 15.721C23.2073 15.721 23.5396 15.8341 23.7796 16.0602C24.0242 16.2864 24.1465 16.6025 24.1465 17.0086C24.1465 17.4286 24.0242 17.7655 23.7796 18.0193C23.5349 18.2732 23.1588 18.4001 22.6511 18.4001H21.585V19.9646H22.6442C23.7519 19.9646 24.3057 20.4677 24.3057 21.4738C24.3057 21.8892 24.1695 22.2238 23.8972 22.4776C23.6296 22.7268 23.258 22.8514 22.7827 22.8514C22.3673 22.8514 22.0166 22.7314 21.7304 22.4914C21.4489 22.2514 21.3081 21.9422 21.3081 21.5638H19.3075C19.3075 22.0004 19.3872 22.3942 19.5468 22.7453C19.706 23.0955 19.9447 23.4032 20.2628 23.6683C20.9043 24.199 21.7281 24.4644 22.7342 24.4644C23.8095 24.4644 24.6726 24.1944 25.3233 23.6545ZM22.5576 17.2186C22.5874 17.126 22.6061 17.0284 22.6121 16.9274C22.6434 16.9146 22.695 16.9025 22.7827 16.9025C22.8769 16.9025 22.9322 16.9134 22.9591 16.921C22.9621 16.9395 22.965 16.968 22.965 17.0086C22.965 17.1043 22.9511 17.154 22.9442 17.1731C22.9425 17.1777 22.941 17.1813 22.9395 17.1843C22.9385 17.1847 22.9374 17.185 22.9363 17.1854C22.8984 17.1982 22.8106 17.2186 22.6511 17.2186H22.5576Z"
                                    fill="#C28044"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3244_228">
                                    <rect width="46" height="43" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>

                              <div className="showDetailsJudesName horseCardDescription fw-bold  ms-3">
                                {windowWidth > 991
                                  ? truncateString(
                                    `${item.bronzeHorse.horseNumber} - ${item.bronzeHorse.horseName}`
                                  )
                                  : item.bronzeHorse.horseNumber +
                                  " - " +
                                  item.bronzeHorse.horseName}
                              </div>
                            </div>
                          )}
                        </div>
                        <div>
                          {item.hasScoringDetails && (
                            <React.Fragment>


                              <CustomPopUp
                                lockScroll
                                trigger={<div className="col-md-6 col-sm-12 col-12 ms-auto  rtl">
                                  <PillBtn
                                    isSubmitBtn
                                    isWithClass
                                    isNoMargin
                                    onClick={() => { handleChampionshipResult(item.id); setChampionshipName(item.championshipName); }
                                    }
                                    classes="btn-danger"
                                    text={translate("web.judgeCard", "Judge Card")}
                                  />
                                </div>}
                                onOpen={() => {
                                  setOpenPopup((o) => !o);
                                }}
                                closeOnDocumentClick={false}
                                closeOnEscape
                                key={'Cart' + iShowChampionshipCardsData}
                                content={<>
                                  <h6>{championshipName}</h6>
                                  <div className="scrolableTable  mb-form-group" >
                                    <table
                                      className="table table-striped table-bordered"
                                      style={{
                                        direction:
                                          currentLanguage == "ar"
                                            ? "rtl"
                                            : "ltr",
                                      }}
                                    >
                                      <thead
                                        className="fw-bold"
                                        style={{
                                          color: "white",
                                        }}
                                      >
                                        <tr>
                                          {!!championshipResultData &&
                                            !showsLoading &&
                                            !!championshipResultData?.result?.headers &&
                                            championshipResultData?.result?.headers.map(
                                              (item, i) => (
                                                <th
                                                  className="text-center"
                                                  key={i}
                                                >
                                                  {item}
                                                </th>
                                              )
                                            )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {!!championshipResultData &&
                                          !showsLoading &&
                                          !!championshipResultData?.result?.results &&
                                          championshipResultData?.result?.results.map(
                                            (item, i) => (
                                              <tr key={i}>
                                                {!!item &&
                                                  item.rowData.map(
                                                    (ele, ind) => (
                                                      <td key={ind}>{ele}</td>
                                                    )
                                                  )}
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="w-100 row">
                                    {championshipResultData?.result?.judges?.map((judge, index) => (
                                      <div key={index} className="col-md-3">
                                        <div className="flagJudgDiv">
                                          <span>{judge?.letter}</span>
                                          <img
                                            className="countryFlageImg flagJudgimg"
                                            src={judge?.countryFlag}
                                            alt={judge?.countryName}
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src = `${BaseURL}/assets/img/whitebgimg.png`;
                                            }}
                                          />
                                          <span
                                            style={{
                                              marginLeft: 8,
                                            }}
                                          >
                                            {judge?.name}
                                          </span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </>
                                }
                                title={showbyIdData?.showName}
                              />
                            </React.Fragment>
                          )}

                          {item.goldHorse == null &&
                            item.silverHorse == null &&
                            item.bronzeHorse == null && (
                              <h2
                                className="row text-danger text-center  col-md-12"
                                style={{ minHeight: 174 }}
                              >
                                {translate(
                                  "web.nodataFound",
                                  "No Data Found !"
                                )}
                              </h2>
                            )}
                        </div>
                      </div>
                    </div>
                  )
              )
            ) : (
              <div
                className="row text-danger  text-center col-md-12"
                style={{ position: "relative" }}
              >
                <h2>{translate("web.nodataFound", "No Data Found !")}</h2>
              </div>
            )}
          </EahsForm>
        </div>
      ) : <></>
      }

      <SpecialPrizesSection key={'SpecizlPrizes'} showId={currentId} />

      {/* Classes */}
      {!!showClassesData && showClassesData.length > 0 && (
        <div className="pt-5">
          <EahsForm key={'classes'} className='mb-main' isSectionTitle={true} isNoMargin title={translate("web.classes", "Classes")}  >
            <div className="col-md-12  responsiveRTLWidth100 text-center-rtl">
              {!!showClassesData && showClassesData.length > 0 ? (
                //accordionFirst
                <div
                  className=" accordionShowDetails rtl"
                  id="accordionFirst"
                >
                  {showClassesData.map((item, i) => (
                    <div className="panel-default mb-2" key={i}>
                      <div className="panel-headin row brownImp rounded">
                        <div className="panel-title showTableTabHeader text-right-rtl t-center-responsive col-md-12 col-sm-12">
                          <a
                            className="collapsed text-collapse"
                            data-bs-toggle="collapse"
                            href={`#collapseFirst${i}`}
                            aria-expanded="false"
                            aria-controls={`collapseFirst${i}`}
                          >
                            <span className="text-start w-75 d-inline-block">
                              {formatLongDate(item.dayDate)}
                            </span>
                            <span className="text-end w-25 d-inline-block">
                              <i className="fa-solid fa-chevron-down" />
                            </span>
                          </a>
                        </div>
                      </div>
                      <div
                        id={`collapseFirst${i}`}
                        className="panel-collapse collapse"
                        data-bs-parent="#accordionFirst"
                      >
                        <div className="panel-body panelBodyResponsive">
                          {
                            //accordionSecond
                          }

                          <div className="panel-group" id={`accordionSecond${i}`}>
                            {item.showClassesList.map((item2, i2) => (
                              <div className=" panel-default rounded" key={i2}>
                                <div className="panel-heading accordionSecondShowDetails rounded">
                                  <h4
                                    className="panel-title showTableTabHeader rounded"
                                    style={{
                                      backgroundColor: "var(--mainGold)",
                                    }}
                                  >
                                    <a
                                      className={`collapsed border  ${i2 % 2 != 0 ? 'bg-gray' : 'bg-white'}`}
                                      data-bs-toggle="collapse"
                                      href={`#collapseSecond${i}${i2}`}
                                      aria-expanded="false"
                                      aria-controls={`collapseSecond${i}${i2}`}
                                      style={{ overflowX: 'hidden' }}
                                    >
                                      <span className={`w-75 text-start d-inline-block ${i2 % 2 != 0 ? 'text-dark' : 'text-dark'} `}>
                                        {item2.className}
                                      </span>
                                      <span className={`w-25 text-end d-inline-block ${i2 % 2 != 0 ? 'text-dark' : 'text-dark'}`}>
                                        {item2?.showClassHorseList?.length}
                                        <i className="fa-solid fa-horse-head ms-2"></i>
                                        {!!item2?.videoUrl ?
                                          <i className="fa-solid px-3 d-inline-block fa-film" style={{ cursor: 'pointer' }} onClick={() => showChampionVideo([item2?.videoUrl])} ></i> : <></>}
                                      </span>
                                    </a>
                                  </h4>
                                </div>
                                {item2.showClassHorseList?.filter((horse) => horse?.horseName)?.length > 0 &&
                                  <>
                                    <div
                                      id={`collapseSecond${i}${i2}`}
                                      className="panel-collapse collapse"
                                      data-bs-parent={`#accordionSecond${i}`}
                                      style={{ overflowX: 'hidden' }}
                                    >
                                      <div className="panel-body panelBodyResponsive">
                                        {
                                          //accordionThird
                                        }

                                        <div
                                          className="panel-group"
                                          id={`accordionThird${i}${i2}`}
                                        >
                                          {item2.showClassHorseList.map(
                                            (item3, i3) => (
                                              <div
                                                className=" panel-default"
                                                key={i3}
                                              >
                                                <div
                                                  className={`panel-headin row   accordionThirdShowDetails border  ${i3 % 2 == 0 ? 'bg-gray' : 'bg-white'}`}
                                                  onClick={() => {
                                                    setScoringId(item3.id);
                                                  }}
                                                >
                                                  <div className="panel-title showTableTabHeader  t-center-responsive floatLeftinArabic col-md-2 col-sm-6">
                                                    <a
                                                      className={`collapsed`}
                                                      data-bs-toggle="collapse"
                                                      href={`#collapseThird${i}${i2}${i3}`}
                                                      aria-expanded="false"
                                                      aria-controls={`collapseThird${i}${i2}${i3}`}
                                                    >
                                                      {item3.rank}
                                                    </a>
                                                  </div>
                                                  <div className="panel-title showTableTabHeader d-flex t-center-responsive floatLeftinArabic col-md-5 col-sm-6">
                                                    {!!item3?.studBookHorseId ?
                                                      <div className="my-auto" >
                                                        <span  >
                                                          <Link
                                                            target="_blank"
                                                            to={!!item3?.studBookHorseId ? `/horseDetails?horseId=${item3?.studBookHorseId}` : ''}
                                                          >
                                                            <span className="text-decoration-underline" style={!!item3?.studBookHorseId ? enabledHorse : {}}>
                                                              {item3.horseNumber} {" - "}{" "}
                                                              {item3.horseName}
                                                            </span>
                                                          </Link>
                                                        </span>
                                                      </div>
                                                      :
                                                      <a
                                                        className={`collapsed`}
                                                        data-bs-toggle="collapse"
                                                        href={`#collapseThird${i}${i2}${i3}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapseThird${i}${i2}${i3}`}
                                                      >
                                                        {item3.horseNumber} {" - "}{" "}
                                                        {item3.horseName}
                                                      </a>}
                                                  </div>
                                                  <div className="panel-title showTableTabHeader  t-center-responsive floatLeftinArabic col-md-2 col-sm-6">
                                                    <a
                                                      className="collapsed"
                                                      data-bs-toggle="collapse"
                                                      href={`#collapseThird${i}${i2}${i3}`}
                                                      aria-expanded="false"
                                                      aria-controls={`collapseThird${i}${i2}${i3}`}
                                                    >
                                                      {item3.totalPoint != 0 ? item3.totalPoint : ''} {!!item3.reason && item3.reason}
                                                    </a>
                                                  </div>

                                                  <div className="panel-title showTableTabHeader  text-right-rtl floatLeftinArabic col-md-2 col-sm-6">
                                                    <div className="panel-title   rtl t-center-responsive showTableTabHeader">
                                                      <a
                                                        data-bs-toggle="collapse"
                                                        href={`#collapseThird${i}${i2}${i3}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapseThird${i}${i2}${i3}`}
                                                        className="text-right rotateUp collapsed "
                                                        style={{ padding: "5px 0" }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "var(--mainGold)",
                                                          }}
                                                        >
                                                          {translate(
                                                            "web.results",
                                                            "RESULTS"
                                                          )}

                                                          <i
                                                            className={
                                                              "fas fa-chevron-down iconScoringDetails ms-2"
                                                            }
                                                            style={{ fontSize: 14 }}
                                                          ></i>

                                                        </span>
                                                      </a>
                                                    </div>
                                                  </div>
                                                  <div className="panel-title showTableTabHeader  text-right-rtl floatLeftinArabic d-flex justify-content-center align-items-center col-md-1 col-sm-2">
                                                    <div className="panel-title   rtl t-center-responsive showTableTabHeader ">
                                                      <a
                                                        href={`#collapseThird${i}${i2}${i3}`}
                                                        className="text-right rotateUp collapsed "
                                                        style={{ padding: "5px 0" }}
                                                      >
                                                        {item3?.classHorseGallery?.filter(x => x?.imageUrl?.includes('youtube'))?.length > 0 ?
                                                          <i className="fa-solid px-3 d-inline-block fa-film" style={{ cursor: 'pointer' }} onClick={() => showChampionVideo([item3?.classHorseGallery?.filter(x => x?.imageUrl?.includes('youtube'))[0]?.imageUrl])} ></i> : <></>}
                                                      </a>
                                                    </div>
                                                  </div>

                                                </div>
                                                <div
                                                  id={`collapseThird${i}${i2}${i3}`}
                                                  className="panel-collapse collapse"
                                                  data-bs-parent={`#accordionThird${i}${i2}`}
                                                >
                                                  <div className="panel-body position-relative   panelBodyResponsive showssubTable mx-0 row bgdefault">
                                                    <div className="col-md-4">
                                                      {translate(
                                                        "web.birthDate",
                                                        "Birth Date"
                                                      )}
                                                      <div
                                                        style={{
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        <p> {item3.birthDate} </p>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      {translate(
                                                        "web.sire",
                                                        "Sire"
                                                      )}
                                                      <div>
                                                        <p>{item3.sire} </p>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      {translate(
                                                        "web.breeder",
                                                        "Breeder"
                                                      )}
                                                      <div>
                                                        <p>{item3.breeder} </p>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      {translate(
                                                        "web.color",
                                                        "Color"
                                                      )}
                                                      <div>
                                                        <p>{item3.color} </p>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      {translate("web.dam", "Dam")}
                                                      <div>
                                                        <p>{item3.dam} </p>
                                                      </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                      {translate(
                                                        "web.owner",
                                                        "Owner"
                                                      )}
                                                      <div>
                                                        <p>{item3.owner} </p>
                                                      </div>
                                                    </div>
                                                    {showClassHorseSoringDetailsData?.classHorseGallery?.filter(x => !x?.imageUrl?.includes('youtube')).length > 0  &&
                                                      <div
                                                        className="text-end position-absolute top-0 end-0 ms-1 floatLeftinArabic col-md-1 col-sm-6"
                                                        style={{ padding: '5px 0' }}
                                                        onClick={() => handleHorseMediaClass(showClassHorseSoringDetailsData?.classHorseGallery ?? [])}
                                                      >
                                                        <button className="p-1 border-0 me-4" title={translate('web.viewImages', 'View Images')} style={{ margin: 0 }}>
                                                          <i
                                                            className="fa-regular fa-images"
                                                            aria-hidden="true"
                                                          ></i>
                                                        </button>
                                                      </div>
                                                    }
                                                    {item3.totalPoint != 0 &&
                                                      <HorseResultsTable showbyIdData={showbyIdData} showsLoading={showsLoading} showClassHorseSoringDetailsData={showClassHorseSoringDetailsData} item3={item3} />
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>

                                      </div>
                                      <div className="panel-footer text-end mx-2">
                                        {item2?.isClassCompleted && <Link className={'btn btn-outline-danger mt-2'} title={translate('web.downloadResultAsPdf', 'Dowanload Result As PDF')} target="_blank" to={`${MediaBaseURL}/api/shows/PrintClassDetailsReport?showCategoryClassId=${item2?.id}`}>
                                          <i className='fa-solid fa-file-pdf w-unset' />
                                        </Link>}
                                      </div>
                                      <div
                                        className="panel-footer row"
                                        style={{ backgroundColor: "white" }}
                                      >
                                        {item2.judges.map((item3, i3) => (
                                          <div key={i3} className="col-md-3">
                                            <div className="flagJudgDiv">
                                              <span>{item3.letter}</span>
                                              <img
                                                className="countryFlageImg flagJudgimg"
                                                src={item3.countryFlag}
                                                alt={item3.countryName}
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src = `${BaseURL}/assets/img/whitebgimg.png`;
                                                }}
                                              />
                                              <span
                                                style={{
                                                  marginLeft: 8,
                                                }}
                                              >
                                                {item3.name}
                                              </span>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </>}
                              </div>
                            ))}
                            <div className="panel-group" id={`accordionSecond${i}champ`}>
                              {item?.championships?.map((champ, i2) => (
                                <div className=" panel-default rounded" key={i2}>
                                  <div className="panel-heading accordionSecondShowDetails rounded">
                                    <h4
                                      className="panel-title showTableTabHeader rounded"
                                      style={{
                                        backgroundColor: "var(--mainGold)",
                                      }}
                                    >
                                      <a
                                        className={`collapsed border  ${i2 % 2 != 0 ? 'bg-gray' : 'bg-white'}`}
                                        data-bs-toggle="collapse"
                                        href={`#collapseSecond${i}${i2}champ`}
                                        aria-expanded="false"
                                        aria-controls={`collapseSecond${i}${i2}champ`}
                                        style={{ overflowX: 'hidden' }}
                                      >
                                        <span className={`w-75 text-start d-inline-block ${i2 % 2 != 0 ? 'text-dark' : 'text-dark'} `}>
                                          {champ?.championshipName}
                                        </span>
                                        <span className={`w-25 text-end d-inline-block ${i2 % 2 != 0 ? 'text-dark' : 'text-dark'}`}>
                                          {champ?.horses?.length}
                                          <i className="fa-solid fa-horse-head ms-2"></i>
                                          {!!champ?.videoUrl ?
                                            <i className="fa-solid px-3 d-inline-block fa-film" style={{ cursor: 'pointer' }} onClick={() => showChampionVideo([champ?.videoUrl])} ></i> : <></>}
                                        </span>
                                      </a>
                                    </h4>
                                  </div>
                                  {champ?.horses?.filter((horse) => horse?.horseName)?.length > 0
                                    &&
                                    <>
                                      <div
                                        id={`collapseSecond${i}${i2}champ`}
                                        className="panel-collapse collapse"
                                        data-bs-parent={`#accordionSecond${i}champ`}
                                        style={{ overflowX: 'hidden' }}
                                      >
                                        <div className="panel-body panelBodyResponsive">
                                          {
                                            //accordionThird
                                          }

                                          <div
                                            className="panel-group"
                                            id={`accordionThird${i}${i2}champ`}
                                          >
                                            {champ?.horses?.map(

                                              (item3, i3) => (
                                                <div
                                                  className=" panel-default"
                                                  key={i3}
                                                >
                                                  <div
                                                    className={`panel-headin row   accordionThirdShowDetails border  ${i3 % 2 == 0 ? 'bg-gray' : 'bg-white'}`}
                                                    onClick={() => {
                                                      openChamp(champ?.championshipId, item3?.horseChampoinID);
                                                    }}
                                                  >
                                                    <div className="panel-title showTableTabHeader  t-center-responsive floatLeftinArabic col-md-2 col-sm-6">
                                                      <a
                                                        className="collapsed"
                                                        data-bs-toggle="collapse"
                                                        href={`#collapseThird${i}${i2}${i3}champ`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapseThird${i}${i2}${i3}champ`}
                                                        dangerouslySetInnerHTML={{ __html: getOrdinal(item3.rank, currentLanguage, true) }}
                                                      >
                                                      </a>
                                                    </div>
                                                    <div className="panel-title showTableTabHeader d-flex  t-center-responsive floatLeftinArabic col-md-5 col-sm-6">
                                                      {!!item3?.studBookHorseId ?
                                                        <div className="my-auto" >
                                                          <span  >
                                                            <Link
                                                              target="_blank"
                                                              to={!!item3?.studBookHorseId ? `/horseDetails?horseId=${item3?.studBookHorseId}` : ''}
                                                            >
                                                              <span className="text-decoration-underline" style={!!item3?.studBookHorseId ? enabledHorse : {}}>
                                                                {item3.horseNumber} {" - "}{" "}
                                                                {item3.horseName}
                                                              </span>
                                                            </Link>
                                                          </span>
                                                        </div> :
                                                        <a
                                                          className={`collapsed`}
                                                          data-bs-toggle="collapse"
                                                          href={`#collapseThird${i}${i2}${i3}champ`}
                                                          aria-expanded="false"
                                                          aria-controls={`collapseThird${i}${i2}${i3}champ`}
                                                        >
                                                          {item3.horseNumber} {" - "}{" "}
                                                          {item3.horseName}
                                                        </a>
                                                      }
                                                    </div>
                                                    <div className="panel-title showTableTabHeader  t-center-responsive floatLeftinArabic col-md-2 col-sm-6">
                                                      <a
                                                        className="collapsed"
                                                        data-bs-toggle="collapse"
                                                        href={`#collapseThird${i}${i2}${i3}champ`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapseThird${i}${i2}${i3}champ`}
                                                      >
                                                        {item3?.totalPoints != 0 ? item3?.totalPoints?.toFixed(2) : ''} {!!item3?.reason && item3?.reason}
                                                      </a>
                                                    </div>

                                                    <div className="panel-title showTableTabHeader  text-right-rtl floatLeftinArabic col-md-2 col-sm-6">
                                                      <div className="panel-title   rtl t-center-responsive showTableTabHeader">
                                                        <a
                                                          data-bs-toggle="collapse"
                                                          href={`#collapseThird${i}${i2}${i3}champ`}
                                                          aria-expanded="false"
                                                          aria-controls={`collapseThird${i}${i2}${i3}champ`}
                                                          className="text-right rotateUp collapsed "
                                                          style={{ padding: "5px 0" }}
                                                        >
                                                          <span
                                                            style={{
                                                              color: "var(--mainGold)",
                                                            }}
                                                          >
                                                            {translate(
                                                              "web.results",
                                                              "RESULTS"
                                                            )}

                                                            <i
                                                              className={
                                                                "fas fa-chevron-down iconScoringDetails ms-2"
                                                              }
                                                              style={{ fontSize: 14 }}
                                                            ></i>

                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                    <div className="panel-title showTableTabHeader  text-right-rtl floatLeftinArabic d-flex justify-content-center align-items-center col-md-1 col-sm-2">
                                                      <div className="panel-title   rtl t-center-responsive showTableTabHeader ">
                                                        <a
                                                          href={`#collapseThird${i}${i2}${i3}champ`}
                                                          className="text-right rotateUp collapsed "
                                                          style={{ padding: "5px 0" }}
                                                        >
                                                          {item3?.classHorseGallery?.filter(x => x?.imageUrl?.includes('youtube'))?.length > 0 ?
                                                            <i className="fa-solid px-3 d-inline-block fa-film" style={{ cursor: 'pointer' }} onClick={() => showChampionVideo([item3?.classHorseGallery?.filter(x => x?.imageUrl?.includes('youtube'))[0]?.imageUrl])} ></i> : <></>}
                                                        </a>
                                                      </div>
                                                    </div>

                                                  </div>
                                                  <div
                                                    id={`collapseThird${i}${i2}${i3}champ`}
                                                    className="panel-collapse collapse"
                                                    data-bs-parent={`#accordionThird${i}${i2}champ`}
                                                  >
                                                    <div className="panel-body position-relative   panelBodyResponsive showssubTable mx-0 row bgdefault">
                                                      <div className="col-md-4">
                                                        {translate(
                                                          "web.birthDate",
                                                          "Birth Date"
                                                        )}
                                                        <div
                                                          style={{
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          <p> {item3.birthDate} </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-4">
                                                        {translate(
                                                          "web.sire",
                                                          "Sire"
                                                        )}
                                                        <div>
                                                          <p>{item3.sire} </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-4">
                                                        {translate(
                                                          "web.breeder",
                                                          "Breeder"
                                                        )}
                                                        <div>
                                                          <p>{item3.breeder} </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-4">
                                                        {translate(
                                                          "web.color",
                                                          "Color"
                                                        )}
                                                        <div>
                                                          <p>{item3.color} </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-4">
                                                        {translate("web.dam", "Dam")}
                                                        <div>
                                                          <p>{item3.dam} </p>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-4">
                                                        {translate(
                                                          "web.owner",
                                                          "Owner"
                                                        )}
                                                        <div>
                                                          <p>{item3.owner} </p>
                                                        </div>
                                                      </div>
                                                      {showClassHorseSoringDetailsData?.classHorseGallery?.filter(x => !x?.imageUrl?.includes('youtube'))?.length > 0 &&
                                                        <div
                                                          className="text-end position-absolute top-0 end-0 ms-1 floatLeftinArabic col-md-1 col-sm-6"
                                                          style={{ padding: '5px 0' }}
                                                          onClick={() => handleHorseMediaClass(showClassHorseSoringDetailsData?.classHorseGallery ?? [])}
                                                        >
                                                          <button className="p-1 border-0 me-4" title={translate('web.viewImages', 'View Images')} style={{ margin: 0 }}>
                                                            <i
                                                              className="fa-regular fa-images"
                                                              aria-hidden="true"
                                                            ></i>
                                                          </button>
                                                        </div>
                                                      }

                                                      <table
                                                        className="table table-striped table-bordered"
                                                        style={{
                                                          direction:
                                                            currentLanguage == "ar"
                                                              ? "rtl"
                                                              : "ltr",
                                                        }}
                                                      >
                                                        <thead
                                                          className="fw-bold"
                                                          style={{
                                                            color: "white",
                                                          }}
                                                        >
                                                          <tr>
                                                            {championHorseTableHeader?.map(
                                                              (item, i) => (
                                                                <th
                                                                  className="text-center"
                                                                  key={i}
                                                                >
                                                                  {item}
                                                                </th>
                                                              )
                                                            )}
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {!!championHorseTableData &&
                                                            !!championHorseTableData &&
                                                            championHorseTableData.map(
                                                              (item, i) => (
                                                                <tr key={i}>
                                                                  {!!item &&
                                                                    item?.rowData.map(
                                                                      (ele, ind) => (
                                                                        <td className="text-center" key={ind} dangerouslySetInnerHTML={{ __html: ele }} ></td>
                                                                      )
                                                                    )}
                                                                </tr>
                                                              )
                                                            )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                        <div className="panel-footer text-end mx-2">
                                          {champ?.isChampionCompleted && <Link className={'btn btn-outline-danger mt-2'} title={translate('web.downloadResultAsPdf', 'Dowanload Result As PDF')} target="_blank" to={`${MediaBaseURL}/api/shows/PrintchampionShipReport?championShipId=${champ?.championshipId}`}>
                                            <i className='fa-solid fa-file-pdf  w-unset' />
                                          </Link>}
                                        </div>
                                        <div
                                          className="panel-footer row"
                                          style={{ backgroundColor: "white" }}
                                        >
                                          {champ?.judges?.map((item3, i3) => (
                                            <div key={i3} className="col-md-3">
                                              <div className="flagJudgDiv">
                                                <span>{item3?.letter}</span>
                                                <img
                                                  className="countryFlageImg flagJudgimg"
                                                  src={item3?.countryFlag}
                                                  alt={item3?.countryName}
                                                  onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = `${BaseURL}/assets/img/whitebgimg.png`;
                                                  }}
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: 8,
                                                  }}
                                                >
                                                  {item3?.name}
                                                </span>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </>}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <span className="text-danger text-center  rtl text-right-rtl">
                  {translate("web.nodataFound", "No Data Found !")}
                </span>
              )}
            </div>
            {!!translate('web.verfiedMsg', '') &&
              <h4 class="alert rounded alert-danger mt-2 mx-auto mb-0 " style={{ fontSize: 21 }} role="alert">
                {translate('web.verfiedMsg', '')}
              </h4>
            }

          </EahsForm>
        </div>
      )}


      {!!showMediaData && showMediaData.length > 0 && (
        <div className="col-md-12 mb-main rtl">
          <div className="row">
            <SectionTitle noMargin section_name={translate("web.mediaGallery", "Media Gallery")} />
            <div className="col-md-12 showsGallery">
              {!!showMediaData && showMediaData.length > 0 ? (
                showMediaData.map((item) => (
                  <Album isShowDetailsPage={true} item={item} handleClick={handleHorseMedia} />
                ))
              ) : (
                <span className="text-danger text-center dblock">
                  {translate("web.nodataFound", "No Data Found !")}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
      {!!showNewsData && showNewsData.length > 0 && (
        <div className="col-md-12 rtl ">
          <div className="row">
            <SectionTitle noMargin section_name={translate("web.showNews", "Show News")} />
            <div className="row">
              {!!showNewsData && showNewsData.length > 0 && (
                showNewsData.map((item) => (
                  <Link to={item.newsUrl} target={item.externalLink ? '_blank' : '_self'} className="col-lg-3 col-md-6 col-sm-6 col-12 justRotate " style={{ marginBottom: windowWidth >= 1400 ? 10 : '10px', aspectRatio: '384 / 359' }}>
                    <NewsItemHome item={item} />
                  </Link>
                ))
              )}
            </div>
          </div>
        </div>
      )}

    </>
  );
}




